(function () {
  'use strict';

  var nextItemId = 1;
  var fillFrontsReminderShown = false;
  var fillFrontsReminderKey = 'trc-fill-fronts-reminder-shown';

  function showFillFrontsReminder(reminder) {
    if (!reminder) return;
    if (fillFrontsReminderShown) return;
    try {
      if (window.sessionStorage.getItem(fillFrontsReminderKey)) return;
      window.sessionStorage.setItem(fillFrontsReminderKey, '1');
    } catch (_) { /* Keep the once-per-page fallback when storage is unavailable. */ }
    fillFrontsReminderShown = true;
    reminder.hidden = false;
    reminder.querySelector('[data-trc-fill-reminder-close]').focus();
  }

  function itemId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return 'trc-upload-' + window.crypto.randomUUID();
    }
    return 'trc-upload-' + Date.now().toString(36) + '-' + (nextItemId++).toString(36);
  }

  function openDraftDatabase() {
    return new Promise(function (resolve, reject) {
      if (!window.indexedDB) {
        reject(new Error('Local draft storage is unavailable in this browser.'));
        return;
      }
      var request = window.indexedDB.open('trc-image-deck-editor', 1);
      request.onupgradeneeded = function () {
        if (!request.result.objectStoreNames.contains('drafts')) {
          request.result.createObjectStore('drafts', { keyPath: 'key' });
        }
      };
      request.onsuccess = function () { resolve(request.result); };
      request.onerror = function () { reject(request.error || new Error('Could not open local draft storage.')); };
    });
  }

  function draftOperation(mode, callback) {
    return openDraftDatabase().then(function (database) {
      return new Promise(function (resolve, reject) {
        var transaction = database.transaction('drafts', mode);
        var result;
        transaction.oncomplete = function () { database.close(); resolve(result); };
        transaction.onerror = function () { database.close(); reject(transaction.error || new Error('Could not save this deck locally.')); };
        transaction.onabort = transaction.onerror;
        try { result = callback(transaction.objectStore('drafts')); }
        catch (error) { transaction.abort(); reject(error); }
      });
    });
  }

  function readDraft(key) {
    return openDraftDatabase().then(function (database) {
      return new Promise(function (resolve, reject) {
        var transaction = database.transaction('drafts', 'readonly');
        var request = transaction.objectStore('drafts').get(key);
        request.onsuccess = function () { database.close(); resolve(request.result || null); };
        request.onerror = function () { database.close(); reject(request.error || new Error('Could not restore this deck.')); };
      });
    });
  }

  function writeDraft(value) {
    return draftOperation('readwrite', function (store) { store.put(value); });
  }

  function deleteDraft(key) {
    return draftOperation('readwrite', function (store) { store.delete(key); });
  }

  function contentType(file) {
    if (file.type === 'image/png' || file.type === 'image/jpeg') return file.type;
    if (/\.png$/i.test(file.name)) return 'image/png';
    if (/\.jpe?g$/i.test(file.name)) return 'image/jpeg';
    return '';
  }

  function mount(options) {
    options = options || {};
    var root = options.root;
    if (!root) return null;
    var modal = document.getElementById('trcDeckEditor');
    var dialog = modal && modal.querySelector('.trc-deck-editor__dialog');
    var workspace = modal && modal.querySelector('.trc-deck-editor__workspace');
    var slotsEl = document.getElementById('trcDeckEditorSlots');
    var libraryEl = document.getElementById('trcDeckEditorLibrary');
    var libraryPanel = document.getElementById('trcDeckEditorLibraryPanel');
    var libraryDrop = document.getElementById('trcDeckEditorLibraryDrop');
    var libraryCount = document.getElementById('trcDeckEditorLibraryCount');
    var libraryOpenButton = document.getElementById('trcDeckEditorLibraryOpen');
    var libraryOpenCount = document.getElementById('trcDeckEditorLibraryOpenCount');
    var libraryCloseButton = document.getElementById('trcDeckEditorLibraryClose');
    var importProgress = document.getElementById('trcDeckEditorImportProgress');
    var importProgressLabel = document.getElementById('trcDeckEditorImportProgressLabel');
    var importProgressValue = document.getElementById('trcDeckEditorImportProgressValue');
    var importProgressTrack = document.getElementById('trcDeckEditorImportProgressTrack');
    var importProgressBar = document.getElementById('trcDeckEditorImportProgressBar');
    var launchProgress = document.getElementById('trcDeckEditorLaunchProgress');
    var launchProgressLabel = document.getElementById('trcDeckEditorLaunchProgressLabel');
    var launchProgressValue = document.getElementById('trcDeckEditorLaunchProgressValue');
    var launchProgressTrack = document.getElementById('trcDeckEditorLaunchProgressTrack');
    var launchProgressBar = document.getElementById('trcDeckEditorLaunchProgressBar');
    var closedPreview = document.getElementById('trcDeckEditorClosedPreview');
    var filledEl = document.getElementById('trcDeckEditorFilled');
    var messageEl = document.getElementById('trcDeckEditorMessage');
    var slotFilterEl = document.getElementById('trcDeckEditorSlotFilter');
    var viewEl = document.getElementById('trcDeckEditorView');
    var sizeEl = document.getElementById('trcDeckEditorSize');
    var fillReminder = document.getElementById('trcDeckEditorFillReminder');
    function closeFillReminder(restoreFocus) {
      if (!fillReminder || fillReminder.hidden) return;
      fillReminder.hidden = true;
      if (restoreFocus && autofillButton) autofillButton.focus();
    }
    if (fillReminder) fillReminder.addEventListener('click', function(event) {
      if (event.target === fillReminder || event.target.closest('[data-trc-fill-reminder-close]')) closeFillReminder(true);
    });
    var bulkInput = document.getElementById('customImageFiles');
    var addImagesButton = document.getElementById('trcDeckEditorAddImages');
    var slotInput = document.getElementById('trcDeckEditorSlotFile');
    var cloudImportButton = document.getElementById('trcDeckEditorCloudImport');
    var cloudImport = document.getElementById('trcDeckEditorCloud');
    var cloudDialog = cloudImport && cloudImport.querySelector('.trc-deck-editor__cloud-dialog');
    var cloudProviders = document.getElementById('trcDeckEditorCloudProviders');
    var cloudStatus = document.getElementById('trcDeckEditorCloudStatus');
    var googleDriveButton = document.getElementById('trcDeckEditorGoogleDrive');
    var dropboxButton = document.getElementById('trcDeckEditorDropbox');
    var dropboxBrowser = document.getElementById('trcDeckEditorDropboxBrowser');
    var dropboxEntriesEl = document.getElementById('trcDeckEditorDropboxEntries');
    var dropboxPathEl = document.getElementById('trcDeckEditorDropboxPath');
    var dropboxUpButton = document.getElementById('trcDeckEditorDropboxUp');
    var dropboxFolderButton = document.getElementById('trcDeckEditorDropboxFolder');
    var dropboxSelectedButton = document.getElementById('trcDeckEditorDropboxSelected');
    var defaultBackEl = document.getElementById('trcDeckEditorDefaultBack');
    var changeBackButton = document.getElementById('trcDeckEditorChangeBack');
    var resetBackButton = document.getElementById('trcDeckEditorResetBack');
    var autofillButton = document.getElementById('trcDeckEditorFillFronts');
    var libraryActionMenu = document.getElementById('trcDeckEditorActionMenu');
    var clearLibraryButton = document.getElementById('trcDeckEditorClearLibrary');
    var resetSlotsButton = document.getElementById('trcDeckEditorResetSlots');
    var libraryFilterButtons = Array.from(document.querySelectorAll('[data-trc-library-filter]'));
    var libraryFilterAllCount = document.getElementById('trcDeckEditorFilterAllCount');
    var libraryFilterUsedCount = document.getElementById('trcDeckEditorFilterUsedCount');
    var libraryFilterUnusedCount = document.getElementById('trcDeckEditorFilterUnusedCount');
    var assignment = document.getElementById('trcDeckEditorAssignment');
    var assignmentDialog = assignment && assignment.querySelector('.trc-deck-editor__assignment-dialog');
    var assignmentImage = document.getElementById('trcDeckEditorAssignmentImage');
    var assignmentName = document.getElementById('trcDeckEditorAssignmentName');
    var assignmentMeta = document.getElementById('trcDeckEditorAssignmentMeta');
    var assignmentSlot = document.getElementById('trcDeckEditorAssignmentSlot');
    var assignmentHint = document.getElementById('trcDeckEditorAssignmentHint');
    var assignmentConfirm = document.getElementById('trcDeckEditorAssignmentConfirm');
    var assignmentSideButtons = assignment
      ? Array.from(assignment.querySelectorAll('[data-trc-assignment-side]'))
      : [];
    if (!modal || !dialog || !slotsEl || !libraryEl || !bulkInput || !slotInput) return null;
    var modalAnchor = document.createComment('trc-deck-editor-home');
    modal.parentNode.insertBefore(modalAnchor, modal);

    var slotCountControl = document.getElementById('trcDeckEditorSlotCountControl');
    var slotCountInput = document.getElementById('trcDeckEditorSlotCount');
    if (slotCountControl) slotCountControl.hidden = !options.exactQuantity;
    var slotPage = 0;
    var draggedSlotCard = null;
    var dragEdgeZone = null;
    var dragEdgeTimer = null;
    var deferredDragRender = false;
    var slotPageSize = 100;
    var previousSlotFilter = 'all';
    var slotPages = document.createElement('nav');
    slotPages.className = 'trc-deck-editor__pages';
    slotPages.setAttribute('aria-label', 'Card slot pages');
    slotPages.hidden = true;
    var previousSlotPage = document.createElement('button');
    previousSlotPage.type = 'button'; previousSlotPage.textContent = 'Previous';
    previousSlotPage.setAttribute('aria-label', 'Previous page');
    var slotPageNumbers = document.createElement('div');
    slotPageNumbers.className = 'trc-deck-editor__page-numbers';
    var nextSlotPage = document.createElement('button');
    nextSlotPage.type = 'button'; nextSlotPage.textContent = 'Next';
    nextSlotPage.setAttribute('aria-label', 'Next page');
    var slotPageSummary = document.createElement('span');
    slotPageSummary.className = 'trc-deck-editor__page-summary';
    slotPageSummary.setAttribute('aria-live', 'polite');
    slotPages.append(previousSlotPage, slotPageNumbers, slotPageSummary, nextSlotPage);
    var editorFooter = modal.querySelector('.trc-deck-editor__footer');
    if (editorFooter) editorFooter.insertBefore(slotPages, editorFooter.querySelector('.trc-deck-editor__footer-actions'));
    else slotsEl.after(slotPages);
    function changeSlotPage(next) {
      slotPage = next;
      prepareRenderLookups();
      try { renderSlots(); } finally { clearRenderLookups(); }
      if (workspace) workspace.scrollTop = 0;
    }
    function resetDragEdge() {
      if (dragEdgeTimer) window.clearTimeout(dragEdgeTimer);
      dragEdgeTimer = null; dragEdgeZone = null;
      if (workspace) workspace.removeAttribute('data-page-edge');
    }
    function updateDragEdge(event) {
      if (!workspace || !editorImageDrag(event) || slotPages.hidden) { resetDragEdge(); return; }
      var rect = workspace.getBoundingClientRect();
      var edge = Math.min(56, Math.max(28, rect.width * .08));
      var x = Number(event.clientX), y = Number(event.clientY);
      var inside = x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
      var zone = inside ? (x <= rect.left + edge ? 'left' : x >= rect.right - edge ? 'right' : null) : null;
      if (zone === dragEdgeZone) { if (zone) event.preventDefault(); return; }
      resetDragEdge(); dragEdgeZone = zone;
      if (!zone || (zone === 'left' ? previousSlotPage.disabled : nextSlotPage.disabled)) return;
      event.preventDefault();
      workspace.setAttribute('data-page-edge', zone);
      // One turn per edge entry. Leaving the edge is required to re-arm it.
      dragEdgeTimer = window.setTimeout(function () {
        dragEdgeTimer = null;
        if (dragEdgeZone !== zone) return;
        workspace.removeAttribute('data-page-edge');
        changeSlotPage(slotPage + (zone === 'right' ? 1 : -1));
      }, 500);
    }
    function finishPagedDrag() {
      resetDragEdge();
      var needsRender = deferredDragRender || !!draggedSlotCard;
      deferredDragRender = false; draggedSlotCard = null; activeSlotDrag = null;
      draggedLibraryImage = false;
      if (needsRender) render();
    }
    previousSlotPage.addEventListener('click', function () { changeSlotPage(slotPage - 1); });
    nextSlotPage.addEventListener('click', function () { changeSlotPage(slotPage + 1); });
    slotPageNumbers.addEventListener('click', function (event) {
      var button = event.target.closest('[data-slot-page]');
      if (button && slotPageNumbers.contains(button)) changeSlotPage(Number(button.dataset.slotPage));
    });
    var minimum = 1;
    var maximum = Math.max(minimum, Number(options.maximum || (options.exactQuantity ? 100 : root.dataset.maximum || 100)));
    var initialMaximum = maximum;
    var minImageWidth = Math.max(1, Number(options.minImageWidth || root.dataset.minImageWidth || 822));
    var minImageHeight = Math.max(1, Number(options.minImageHeight || root.dataset.minImageHeight || 1122));
    var bleedPx = Math.max(0, Number(options.bleedPx || root.dataset.bleedPx || 36));
    var cropScaleX = minImageWidth / Math.max(1, minImageWidth - (bleedPx * 2));
    var cropScaleY = minImageHeight / Math.max(1, minImageHeight - (bleedPx * 2));
    var finishedRatio = Math.max(1, minImageHeight - (bleedPx * 2)) / Math.max(1, minImageWidth - (bleedPx * 2));
    var supportsContainerUnits = !!(window.CSS && typeof CSS.supports === 'function' && CSS.supports('height', '1cqw'));
    var items = [];
    var slots = [];
    // Fixed-size products only: filled slots beyond the current size (after a
    // smaller variant is chosen or a larger draft is restored) are kept here,
    // saved with the draft, and come back if the size grows again.
    var hiddenSlots = [];
    var pickTarget = null;
    var lastFocus = null;
    var fileError = '';
    var refreshScheduled = false;
    var emptyCloseAttempted = false;
    var persistenceKey = options.persistenceKey || root.dataset.persistenceKey || ('trc-custom-deck-v2:' + location.pathname);
    var defaultBackFile = null;
    var saveTimer = null;
    var saveGeneration = 0;
    var saveInFlight = null;
    var closeSavePromise = null;
    var draftDirty = false;
    var restoringDraft = true;
    var autosaveError = '';
    var backgroundState = [];
    var importProgressTimer = null;
    var undoStack = [];
    var redoStack = [];
    var historyLimit = 50;
    var applyingHistory = false;
    var activeSlotDrag = null;
    var defaultBackDragPreview = null;
    var autoScrollFrame = null;
    var autoScrollVelocity = 0;
    var assignmentItemId = null;
    var assignmentSide = 'front';
    var assignmentLastFocus = null;
    var draggedLibraryImage = false;
    var cloudLastFocus = null;
    var cloudBusy = false;
    var googleAccessToken = '';
    var googleLibrariesPromise = null;
    var googleLibrariesReady = false;
    var dropboxAccessToken = '';
    var dropboxOauthPopup = null;
    var dropboxPopupPoll = null;
    var dropboxOauthState = '';
    var dropboxCodeVerifier = '';
    var dropboxPath = '';
    var dropboxPathStack = [];
    var dropboxEntries = [];
    var dropboxSelectedEntries = new Map();
    var renderItemLookup = null;
    var renderUsageLookup = null;
    var inspectionQueue = [];
    var activeInspections = 0;
    var inspectionConcurrency = 2;
    var inspectionBatchTotal = 0;
    var inspectionBatchCompleted = 0;
    var libraryFilter = 'unused';

    var googleClientId = root.dataset.googleDriveClientId || '';
    var googleApiKey = root.dataset.googleDriveApiKey || '';
    var googleAppId = root.dataset.googleDriveAppId || '';
    var dropboxAppKey = root.dataset.dropboxAppKey || '';

    function stateSnapshot() {
      return {
        items: items.slice(),
        slots: slots.map(function (slot) { return { front: slot.front || null, back: slot.back || null }; }),
        defaultBackFile: defaultBackFile,
        fileError: fileError,
        emptyCloseAttempted: emptyCloseAttempted,
      };
    }

    function rememberForUndo() {
      if (applyingHistory) return;
      undoStack.push(stateSnapshot());
      if (undoStack.length > historyLimit) undoStack.shift();
      redoStack = [];
    }

    function restoreSnapshot(snapshot) {
      if (!snapshot) return;
      var previousDefaultBack = defaultBackFile;
      applyingHistory = true;
      items = snapshot.items.slice();
      slots = snapshot.slots.map(function (slot) { return { front: slot.front || null, back: slot.back || null }; });
      if (options.exactQuantity) maximum = slots.length;
      defaultBackFile = snapshot.defaultBackFile || null;
      fileError = snapshot.fileError || '';
      emptyCloseAttempted = !!snapshot.emptyCloseAttempted;
      applyingHistory = false;
      if (previousDefaultBack !== defaultBackFile && typeof options.onRestoreDefaultBack === 'function') {
        options.onRestoreDefaultBack(defaultBackFile);
      }
      render();
      emitChange();
    }

    function undo() {
      if (!undoStack.length) return false;
      redoStack.push(stateSnapshot());
      restoreSnapshot(undoStack.pop());
      return true;
    }

    function redo() {
      if (!redoStack.length) return false;
      undoStack.push(stateSnapshot());
      restoreSnapshot(redoStack.pop());
      return true;
    }

    function liveSlots(list) {
      var validIds = new Set(items.map(function (item) { return item.id; }));
      var live = (list || []).map(function (slot) {
        return {
          front: slot && validIds.has(slot.front) ? slot.front : null,
          back: slot && validIds.has(slot.back) ? slot.back : null,
        };
      });
      while (live.length && !live[live.length - 1].front && !live[live.length - 1].back) live.pop();
      return live;
    }

    function makeSlots(count) {
      var old = slots;
      slots = Array.from({ length: count }, function (_, index) {
        return old[index] || { front: null, back: null };
      });
    }
    makeSlots(maximum);

    function draftValue() {
      return {
        key: persistenceKey,
        version: 2,
        maximum: maximum,
        savedAt: new Date().toISOString(),
        // Persist the filename separately. Some IndexedDB implementations
        // deserialize File values as plain Blobs even though the bytes and MIME
        // type survive, which would otherwise replace the customer's filename.
        items: items.map(function (item) { return { id: item.id, file: item.file, name: item.file.name }; }),
        slots: slots.concat(options.exactQuantity ? [] : hiddenSlots).map(function (slot) { return { front: slot.front || null, back: slot.back || null }; }),
        defaultBackFile: defaultBackFile,
        defaultBackName: defaultBackFile ? defaultBackFile.name : '',
      };
    }

    function hasDraftData() {
      return items.length > 0 || !!defaultBackFile || slots.some(function (slot) {
        return !!slot.front || !!slot.back;
      });
    }

    function saveDraftNow() {
      if (restoringDraft) return Promise.resolve(true);
      if (saveTimer) window.clearTimeout(saveTimer);
      saveTimer = null;
      var generation = ++saveGeneration;
      saveInFlight = writeDraft(draftValue()).then(function () {
        if (generation !== saveGeneration) return;
        var recovered = !!autosaveError;
        autosaveError = '';
        draftDirty = false;
        if (recovered) notifyChange();
        if (navigator.storage && typeof navigator.storage.persist === 'function') {
          navigator.storage.persist().catch(function () {});
        }
        return true;
      }).catch(function (error) {
        autosaveError = 'Your draft could not be saved in this browser. Keep this page open until your upload has started.';
        console.error('TRC deck autosave failed', error);
        if (!modal.hidden) render();
        notifyChange();
        throw error;
      }).finally(function () {
        saveInFlight = null;
      });
      return saveInFlight;
    }

    function scheduleDraftSave() {
      if (restoringDraft) return;
      if (saveTimer) window.clearTimeout(saveTimer);
      draftDirty = true;
      saveTimer = window.setTimeout(function () { saveDraftNow().catch(function () {}); }, 650);
    }

    function flushDraftSave() {
      if (restoringDraft) return Promise.resolve(true);
      if (saveTimer) window.clearTimeout(saveTimer);
      saveTimer = null;
      var pendingSave = saveInFlight;
      var ready = pendingSave
        ? pendingSave.catch(function () { return false; })
        : Promise.resolve(true);
      return ready.then(function () { return saveDraftNow(); });
    }

    function storageCapacityFor(files) {
      if (!navigator.storage || typeof navigator.storage.estimate !== 'function') return Promise.resolve(true);
      var incoming = Array.from(files || []).reduce(function (sum, file) { return sum + Number(file.size || 0); }, 0);
      return navigator.storage.estimate().then(function (estimate) {
        var quota = Number(estimate.quota || 0);
        var usage = Number(estimate.usage || 0);
        if (!quota) return true;
        // Leave 10% headroom for IndexedDB bookkeeping and future edits.
        return usage + Math.ceil(incoming * 1.1) <= quota * 0.9;
      }).catch(function () { return true; });
    }

    function restoreDraft() {
      return readDraft(persistenceKey).then(function (draft) {
        if (!draft || draft.version !== 2 || !Array.isArray(draft.items)) return;
        items.forEach(function (item) {
          if (item.url) URL.revokeObjectURL(item.url);
          if (item.previewUrl) URL.revokeObjectURL(item.previewUrl);
        });
        items = draft.items.map(function (saved) {
          if (!saved || !(saved.file instanceof Blob) || !contentType(saved.file)) return null;
          var file = saved.file instanceof File
            ? saved.file
            : new File([saved.file], saved.name || saved.file.name || 'custom-card.png', { type: saved.file.type });
          var item = {
            id: saved.id || itemId(),
            file: file,
            url: URL.createObjectURL(file),
            previewUrl: '',
            width: 0,
            height: 0,
            resolutionState: 'checking',
          };
          return item;
        }).filter(Boolean);
        var restoredInspections = 0;
        items.forEach(function (item) {
          inspectResolution(item, function () {
            restoredInspections++;
            if (restoredInspections === items.length || restoredInspections % 8 === 0) scheduleRefresh();
          }, { deferRefresh: true });
        });
        if (options.exactQuantity && !items.length && !draft.defaultBackFile) maximum = initialMaximum;
        else if (options.exactQuantity && Number.isInteger(draft.maximum) && draft.maximum >= 1 && draft.maximum <= 1000) maximum = draft.maximum;
        var validIds = new Set(items.map(function (item) { return item.id; }));
        slots = Array.from({ length: maximum }, function (_, index) {
          var savedSlot = Array.isArray(draft.slots) ? draft.slots[index] : null;
          return {
            front: savedSlot && validIds.has(savedSlot.front) ? savedSlot.front : null,
            back: savedSlot && validIds.has(savedSlot.back) ? savedSlot.back : null,
          };
        });
        hiddenSlots = !options.exactQuantity && Array.isArray(draft.slots) ? liveSlots(draft.slots.slice(maximum)) : [];
        if (draft.defaultBackFile instanceof Blob && contentType(draft.defaultBackFile)) {
          defaultBackFile = draft.defaultBackFile instanceof File
            ? draft.defaultBackFile
            : new File([draft.defaultBackFile], draft.defaultBackName || draft.defaultBackFile.name || 'card-back.png', { type: draft.defaultBackFile.type });
          if (typeof options.onRestoreDefaultBack === 'function') options.onRestoreDefaultBack(defaultBackFile);
        }
      }).catch(function (error) {
        autosaveError = 'A saved draft could not be restored. You can still build a new deck.';
        console.error('TRC deck restore failed', error);
      }).finally(function () {
        restoringDraft = false;
        undoStack = [];
        redoStack = [];
        render();
        // Restoring (or finding no draft) is initialization, not customer input.
        // Notify the product form without creating a new unsaved draft.
        notifyChange();
      });
    }

    function scheduleRefresh() {
      if (refreshScheduled) return;
      refreshScheduled = true;
      // Large imports decode in a queue. Rebuilding the library after every
      // pair of images starves that queue and makes the editor unresponsive.
      var schedule = items.length > 100
        ? function (callback) { return window.setTimeout(callback, 200); }
        : window.requestAnimationFrame || function (callback) { return window.setTimeout(callback, 0); };
      schedule(function () {
        refreshScheduled = false;
        render();
        emitChange();
      });
    }

    function previewFromBitmap(item, bitmap) {
      var longest = Math.max(bitmap.width, bitmap.height);
      var scale = Math.min(1, 640 / Math.max(1, longest));
      var canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(bitmap.width * scale));
      canvas.height = Math.max(1, Math.round(bitmap.height * scale));
      var context = canvas.getContext && canvas.getContext('2d');
      if (!context || typeof canvas.toBlob !== 'function') return Promise.resolve(false);
      context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
      return new Promise(function (resolve) {
        canvas.toBlob(function (blob) {
          if (blob) {
            if (item.previewUrl) URL.revokeObjectURL(item.previewUrl);
            item.previewUrl = URL.createObjectURL(blob);
          }
          resolve(!!blob);
        }, 'image/webp', .84);
      });
    }

    function inspectWithImageElement(item) {
      return new Promise(function (resolve, reject) {
        var probe = new Image();
        probe.onload = function () {
          item.width = probe.naturalWidth;
          item.height = probe.naturalHeight;
          resolve(true);
        };
        probe.onerror = function () { reject(new Error('Image could not be decoded.')); };
        probe.src = item.url;
      });
    }

    // The print service refuses images over 20,000 px a side or 100 megapixels.
    // Catch them here, before upload, where the image can still be removed.
    var MAX_PRINT_DIMENSION = 20000;
    var MAX_PRINT_PIXELS = 100000000;
    function oversizeImage(width, height) {
      return width > MAX_PRINT_DIMENSION || height > MAX_PRINT_DIMENSION || width * height > MAX_PRINT_PIXELS;
    }

    // Width and height from a PNG or JPG header, or null. Reading the header
    // first means a huge photo is flagged without decoding it.
    function headerImageSize(file) {
      var head = file.slice(0, 512 * 1024);
      var read = typeof head.arrayBuffer === 'function'
        ? head.arrayBuffer()
        : new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function () { resolve(reader.result); };
            reader.onerror = function () { reject(reader.error); };
            reader.readAsArrayBuffer(head);
          });
      return read.then(function (buffer) {
        var b = new Uint8Array(buffer);
        if (b.length >= 24 && b[0] === 0x89 && b[1] === 0x50 && b[2] === 0x4e && b[3] === 0x47 &&
            b[12] === 0x49 && b[13] === 0x48 && b[14] === 0x44 && b[15] === 0x52) {
          return {
            width: ((b[16] << 24) >>> 0) + (b[17] << 16) + (b[18] << 8) + b[19],
            height: ((b[20] << 24) >>> 0) + (b[21] << 16) + (b[22] << 8) + b[23],
          };
        }
        if (b.length < 4 || b[0] !== 0xff || b[1] !== 0xd8) return null;
        var offset = 2;
        while (offset + 9 < b.length) {
          if (b[offset] !== 0xff) return null;
          while (offset < b.length && b[offset] === 0xff) offset++;
          var marker = b[offset++];
          if (marker === 0xd8 || marker === 0x01 || (marker >= 0xd0 && marker <= 0xd7)) continue;
          if (marker === 0xd9 || marker === 0xda) return null;
          var length = (b[offset] << 8) | b[offset + 1];
          if (length < 2) return null;
          if (marker >= 0xc0 && marker <= 0xcf && marker !== 0xc4 && marker !== 0xc8 && marker !== 0xcc) {
            if (offset + 7 > b.length) return null;
            return { height: (b[offset + 3] << 8) | b[offset + 4], width: (b[offset + 5] << 8) | b[offset + 6] };
          }
          offset += length;
        }
        return null;
      }).catch(function () { return null; });
    }

    function runInspection(job) {
      var item = job.item;
      var tooLarge = new Error('Image is too large to print.');
      function decode() {
        return typeof window.createImageBitmap === 'function'
          ? window.createImageBitmap(item.file).then(function (bitmap) {
              item.width = bitmap.width;
              item.height = bitmap.height;
              return previewFromBitmap(item, bitmap).finally(function () {
                if (typeof bitmap.close === 'function') bitmap.close();
              });
            }).catch(function () { return inspectWithImageElement(item); })
          : inspectWithImageElement(item);
      }
      var inspect = headerImageSize(item.file).then(function (size) {
        if (size && oversizeImage(size.width, size.height)) {
          item.width = size.width;
          item.height = size.height;
          throw tooLarge;
        }
        return decode();
      }).then(function () {
        if (oversizeImage(item.width, item.height)) throw tooLarge;
      });
      inspect.then(function () {
        item.resolutionState = 'ready';
      }).catch(function (error) {
        item.resolutionState = error === tooLarge ? 'oversize' : 'error';
      }).finally(function () {
        activeInspections--;
        inspectionBatchCompleted++;
        updateResolutionProgress(inspectionBatchCompleted, inspectionBatchTotal);
        if (!job.deferRefresh) scheduleRefresh();
        if (typeof job.onComplete === 'function') job.onComplete();
        pumpInspectionQueue();
      });
    }

    function pumpInspectionQueue() {
      while (activeInspections < inspectionConcurrency && inspectionQueue.length) {
        activeInspections++;
        runInspection(inspectionQueue.shift());
      }
    }

    function inspectResolution(item, onComplete, settings) {
      if (!activeInspections && !inspectionQueue.length && inspectionBatchCompleted >= inspectionBatchTotal) {
        inspectionBatchTotal = 0;
        inspectionBatchCompleted = 0;
      }
      inspectionBatchTotal++;
      updateResolutionProgress(inspectionBatchCompleted, inspectionBatchTotal);
      item.resolutionState = 'checking';
      inspectionQueue.push({
        item: item,
        onComplete: onComplete,
        deferRefresh: !!(settings && settings.deferRefresh),
      });
      pumpInspectionQueue();
    }

    function itemDisplayUrl(item) {
      return item && (item.previewUrl || item.url) || '';
    }

    function updateResolutionProgress(completed, total) {
      if (!total) return;
      if (importProgressTimer) window.clearTimeout(importProgressTimer);
      var percent = Math.max(0, Math.min(100, Math.round((completed / total) * 100)));
      var label = completed < total
        ? ('Checking image resolution: ' + completed + ' of ' + total)
        : ('Checked ' + total + ' image' + (total === 1 ? '' : 's'));
      [
        { root: importProgress, label: importProgressLabel, value: importProgressValue, track: importProgressTrack, bar: importProgressBar },
        { root: launchProgress, label: launchProgressLabel, value: launchProgressValue, track: launchProgressTrack, bar: launchProgressBar },
      ].forEach(function (progress) {
        if (!progress.root) return;
        progress.root.hidden = false;
        if (progress.label) progress.label.textContent = label;
        if (progress.value) progress.value.textContent = percent + '%';
        if (progress.bar) progress.bar.style.width = percent + '%';
        if (progress.track) progress.track.setAttribute('aria-valuenow', String(percent));
      });
      if (completed >= total) {
        importProgressTimer = window.setTimeout(function () {
          if (importProgress) importProgress.hidden = true;
          if (launchProgress) launchProgress.hidden = true;
        }, 900);
      }
    }

    function resolutionValid(item) {
      return item && item.resolutionState === 'ready' &&
        item.width >= minImageWidth && item.height >= minImageHeight;
    }

    function itemById(id) {
      if (renderItemLookup) return renderItemLookup.get(id) || null;
      return items.find(function (item) { return item.id === id; }) || null;
    }

    function prepareRenderLookups() {
      renderItemLookup = new Map();
      renderUsageLookup = new Map();
      items.forEach(function (item) {
        renderItemLookup.set(item.id, item);
        renderUsageLookup.set(item.id, 0);
      });
      slots.forEach(function (slot) {
        [slot.front, slot.back].forEach(function (id) {
          if (id && renderUsageLookup.has(id)) renderUsageLookup.set(id, renderUsageLookup.get(id) + 1);
        });
      });
    }

    function clearRenderLookups() {
      renderItemLookup = null;
      renderUsageLookup = null;
    }

    function applyPrintCrop(image) {
      image.classList.add('trc-deck-editor__print-crop');
      image.style.setProperty('--trc-crop-scale-x', cropScaleX.toFixed(4));
      image.style.setProperty('--trc-crop-scale-y', cropScaleY.toFixed(4));
      image.title = 'Approximate finished crop after bleed is trimmed';
    }

    function openLibrary() {
      if (!libraryPanel) return;
      libraryPanel.classList.add('is-open');
      if (libraryOpenButton) libraryOpenButton.setAttribute('aria-expanded', 'true');
      if (libraryCloseButton) requestAnimationFrame(function () { libraryCloseButton.focus(); });
    }

    function closeLibrary(returnFocus) {
      if (!libraryPanel) return;
      libraryPanel.classList.remove('is-open');
      if (libraryOpenButton) libraryOpenButton.setAttribute('aria-expanded', 'false');
      if (returnFocus !== false && libraryOpenButton && libraryOpenButton.focus) libraryOpenButton.focus();
    }

    function assignmentSlotAllowed(index, side) {
      return !!slots[index] && (side !== 'back' || !!slots[index].front);
    }

    function preferredAssignmentSlot(side) {
      for (var index = 0; index < slots.length; index++) {
        if (assignmentSlotAllowed(index, side) && !slots[index][side]) return index;
      }
      for (var fallback = 0; fallback < slots.length; fallback++) {
        if (assignmentSlotAllowed(fallback, side)) return fallback;
      }
      return -1;
    }

    function refreshAssignmentSlots(preferredValue) {
      if (!assignmentSlot || !assignmentConfirm) return;
      var previous = preferredValue !== undefined && preferredValue !== null
        ? Number(preferredValue)
        : Number(assignmentSlot.value);
      assignmentSlot.innerHTML = '';
      slots.forEach(function (slot, index) {
        var option = document.createElement('option');
        var allowed = assignmentSlotAllowed(index, assignmentSide);
        var occupied = !!slot[assignmentSide];
        option.value = String(index);
        option.disabled = !allowed;
        if (!allowed) {
          option.textContent = 'Slot ' + (index + 1) + ': add a front first';
        } else if (occupied) {
          option.textContent = 'Slot ' + (index + 1) + ': replace current ' + assignmentSide;
        } else if (assignmentSide === 'back') {
          option.textContent = 'Slot ' + (index + 1) + ': using deck card back';
        } else {
          option.textContent = 'Slot ' + (index + 1) + ': empty front';
        }
        assignmentSlot.appendChild(option);
      });
      var selected = assignmentSlotAllowed(previous, assignmentSide)
        ? previous
        : preferredAssignmentSlot(assignmentSide);
      if (selected >= 0) assignmentSlot.value = String(selected);
      assignmentConfirm.disabled = selected < 0;
      if (assignmentHint) {
        if (selected < 0) {
          assignmentHint.textContent = 'Add a card front before assigning a custom back.';
        } else if (slots[selected][assignmentSide]) {
          assignmentHint.textContent = 'This will replace the current ' + assignmentSide + ' in slot ' + (selected + 1) + '.';
        } else {
          assignmentHint.textContent = 'The image will be added to slot ' + (selected + 1) + ' as the ' + assignmentSide + '.';
        }
      }
    }

    function setAssignmentSide(side) {
      assignmentSide = side === 'back' ? 'back' : 'front';
      assignmentSideButtons.forEach(function (button) {
        var selected = button.dataset.trcAssignmentSide === assignmentSide;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      // Placed as a back, the image shows without the foil sheen (fronts only).
      if (assignmentImage && assignmentImage.parentElement) assignmentImage.parentElement.classList.toggle('is-back', assignmentSide === 'back');
      refreshAssignmentSlots(preferredAssignmentSlot(assignmentSide));
    }

    function openImageAssignment(item, trigger) {
      if (!assignment || !assignmentDialog || !item) return;
      assignmentItemId = item.id;
      assignmentLastFocus = trigger || document.activeElement;
      if (assignmentImage) {
        assignmentImage.src = itemDisplayUrl(item);
        assignmentImage.alt = item.file.name;
        if (assignmentImage.parentElement) assignmentImage.parentElement.style.aspectRatio = '1 / ' + finishedRatio.toFixed(4);
        applyPrintCrop(assignmentImage);
      }
      if (assignmentName) assignmentName.textContent = item.file.name;
      if (assignmentMeta) {
        assignmentMeta.textContent = item.resolutionState === 'ready' || item.resolutionState === 'oversize'
          ? item.width + ' × ' + item.height + ' px' + (item.resolutionState === 'oversize' ? ', too large to print' : '') + ' · used ' + usage(item.id) + '×'
          : 'Checking resolution… · used ' + usage(item.id) + '×';
      }
      setAssignmentSide('front');
      assignment.hidden = false;
      requestAnimationFrame(function () { assignmentDialog.focus(); });
    }

    function closeImageAssignment(returnFocus) {
      if (!assignment || assignment.hidden) return;
      assignment.hidden = true;
      assignmentItemId = null;
      if (returnFocus !== false && assignmentLastFocus && assignmentLastFocus.isConnected && assignmentLastFocus.focus) {
        assignmentLastFocus.focus();
      }
      assignmentLastFocus = null;
    }

    function setCloudStatus(message, isError) {
      if (!cloudStatus) return;
      cloudStatus.textContent = message || '';
      cloudStatus.classList.toggle('is-error', !!isError);
    }

    function setCloudProvider(provider) {
      if (!cloudDialog) return;
      var browsing = provider === 'google' || provider === 'dropbox';
      cloudDialog.classList.toggle('is-browsing', browsing);
      if (browsing) cloudDialog.setAttribute('data-cloud-provider', provider);
      else cloudDialog.removeAttribute('data-cloud-provider');
      if (cloudProviders) cloudProviders.hidden = browsing;
      if (provider !== 'dropbox' && dropboxBrowser) dropboxBrowser.hidden = true;
    }

    function showCloudProviders(message, isError) {
      setCloudProvider('');
      if (dropboxBrowser) dropboxBrowser.hidden = true;
      setCloudStatus(message || '', !!isError);
      setCloudBusy(false);
    }

    function setCloudBusy(busy) {
      cloudBusy = !!busy;
      [googleDriveButton, dropboxButton, dropboxUpButton, dropboxFolderButton, dropboxSelectedButton].forEach(function (button) {
        if (!button) return;
        if (button === googleDriveButton) button.disabled = cloudBusy || (!!googleClientId && !!googleApiKey && !!googleAppId && !googleLibrariesReady);
        else if (button === dropboxUpButton) button.disabled = cloudBusy;
        else if (button === dropboxSelectedButton) button.disabled = cloudBusy || dropboxSelectedEntries.size === 0;
        else button.disabled = cloudBusy;
      });
    }

    function openCloudImport() {
      if (!cloudImport || !cloudDialog) return;
      closeImageAssignment(false);
      cloudLastFocus = document.activeElement;
      cloudImport.hidden = false;
      dropboxSelectedEntries.clear();
      showCloudProviders('', false);
      requestAnimationFrame(function () { cloudDialog.focus(); });
      if (googleDriveButton && googleClientId && googleApiKey && googleAppId && !googleLibrariesReady) {
        setCloudBusy(false);
        setCloudStatus('Preparing Google Drive… Dropbox is ready now.', false);
        prepareGoogleLibraries().then(function () {
          if (!cloudImport.hidden && !cloudBusy) {
            setCloudBusy(false);
            setCloudStatus('', false);
          }
        }).catch(function () {
          if (!cloudImport.hidden) {
            setCloudBusy(false);
            setCloudStatus('Google Drive could not be prepared. Dropbox is still available.', true);
          }
        });
      }
    }

    function closeCloudImport(returnFocus) {
      if (!cloudImport || cloudImport.hidden) return;
      if (dropboxPopupPoll) window.clearInterval(dropboxPopupPoll);
      dropboxPopupPoll = null;
      if (dropboxOauthPopup && !dropboxOauthPopup.closed) dropboxOauthPopup.close();
      dropboxOauthPopup = null;
      cloudImport.hidden = true;
      setCloudProvider('');
      if (dropboxBrowser) dropboxBrowser.hidden = true;
      setCloudStatus('', false);
      setCloudBusy(false);
      if (returnFocus !== false && cloudLastFocus && cloudLastFocus.isConnected && cloudLastFocus.focus) {
        cloudLastFocus.focus();
      }
      cloudLastFocus = null;
    }

    function loadExternalScript(id, src, ready) {
      if (ready()) return Promise.resolve(true);
      return new Promise(function (resolve, reject) {
        var script = document.getElementById(id);
        function loaded() {
          if (ready()) resolve(true);
          else reject(new Error('The provider sign-in library did not load.'));
        }
        function failed() { reject(new Error('The provider sign-in library could not be loaded.')); }
        if (!script) {
          script = document.createElement('script');
          script.id = id;
          script.src = src;
          script.async = true;
          script.defer = true;
          document.head.appendChild(script);
        }
        script.addEventListener('load', loaded, { once: true });
        script.addEventListener('error', failed, { once: true });
      });
    }

    function prepareGoogleLibraries() {
      if (googleLibrariesPromise) return googleLibrariesPromise;
      googleLibrariesPromise = Promise.all([
        loadExternalScript('trc-google-api', 'https://apis.google.com/js/api.js', function () { return !!window.gapi; }),
        loadExternalScript('trc-google-identity', 'https://accounts.google.com/gsi/client', function () {
          return !!(window.google && window.google.accounts && window.google.accounts.oauth2);
        }),
      ]).then(function () {
        return new Promise(function (resolve, reject) {
          if (window.google && window.google.picker) {
            resolve(true);
            return;
          }
          window.gapi.load('picker', {
            callback: function () { resolve(true); },
            onerror: function () { reject(new Error('Google Drive Picker could not be loaded.')); },
            timeout: 10000,
            ontimeout: function () { reject(new Error('Google Drive Picker took too long to load.')); },
          });
        });
      }).then(function () {
        googleLibrariesReady = true;
        return true;
      }).catch(function (error) {
        googleLibrariesPromise = null;
        throw error;
      });
      return googleLibrariesPromise;
    }

    function requestGoogleAccessToken() {
      return new Promise(function (resolve, reject) {
        var client = window.google.accounts.oauth2.initTokenClient({
          client_id: googleClientId,
          scope: 'https://www.googleapis.com/auth/drive.readonly',
          callback: function (response) {
            if (!response || response.error || !response.access_token) {
              reject(new Error((response && response.error_description) || 'Google Drive sign-in was not completed.'));
              return;
            }
            googleAccessToken = response.access_token;
            resolve(googleAccessToken);
          },
          error_callback: function () { reject(new Error('Google Drive sign-in was closed or blocked.')); },
        });
        client.requestAccessToken({ prompt: googleAccessToken ? '' : 'consent' });
      });
    }

    function googlePickerDocuments(data) {
      if (!data || data[window.google.picker.Response.ACTION] !== window.google.picker.Action.PICKED) return [];
      return data[window.google.picker.Response.DOCUMENTS] || [];
    }

    function showGooglePicker(token) {
      return new Promise(function (resolve) {
        var imageView = new window.google.picker.DocsView(window.google.picker.ViewId.DOCS_IMAGES)
          .setIncludeFolders(true)
          .setMimeTypes('image/png,image/jpeg');
        var folderView = new window.google.picker.DocsView(window.google.picker.ViewId.FOLDERS)
          .setIncludeFolders(true)
          .setSelectFolderEnabled(true);
        var picker = new window.google.picker.PickerBuilder()
          .addView(imageView)
          .addView(folderView)
          .enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED)
          .setOAuthToken(token)
          .setDeveloperKey(googleApiKey)
          .setAppId(googleAppId)
          .setOrigin(location.protocol + '//' + location.host)
          .setSize(1051, 650)
          .setTitle('Import images from Google Drive')
          .setCallback(function (data) {
            var action = data && data[window.google.picker.Response.ACTION];
            if (action === window.google.picker.Action.PICKED) resolve(googlePickerDocuments(data));
            else if (action === window.google.picker.Action.CANCEL) resolve([]);
          })
          .build();
        picker.setVisible(true);
      });
    }

    function googleDocumentValue(documentObject, key, fallback) {
      return documentObject && (documentObject[key] || documentObject[fallback]) || '';
    }

    async function googleListFolder(folderId, records, seenFolders, seenFiles) {
      if (!folderId || seenFolders.has(folderId)) return;
      seenFolders.add(folderId);
      var pageToken = '';
      do {
        var query = "'" + String(folderId).replace(/'/g, "\\'") + "' in parents and trashed = false";
        var url = new URL('https://www.googleapis.com/drive/v3/files');
        url.searchParams.set('q', query);
        url.searchParams.set('fields', 'nextPageToken,files(id,name,mimeType,size)');
        url.searchParams.set('pageSize', '1000');
        url.searchParams.set('orderBy', 'folder,name_natural');
        url.searchParams.set('supportsAllDrives', 'true');
        url.searchParams.set('includeItemsFromAllDrives', 'true');
        if (pageToken) url.searchParams.set('pageToken', pageToken);
        var response = await fetch(url.toString(), { headers: { Authorization: 'Bearer ' + googleAccessToken } });
        if (!response.ok) throw new Error('Google Drive could not read that folder.');
        var payload = await response.json();
        for (var index = 0; index < (payload.files || []).length; index++) {
          var entry = payload.files[index];
          if (entry.mimeType === 'application/vnd.google-apps.folder') {
            await googleListFolder(entry.id, records, seenFolders, seenFiles);
          } else if ((entry.mimeType === 'image/png' || entry.mimeType === 'image/jpeg') && !seenFiles.has(entry.id)) {
            seenFiles.add(entry.id);
            records.push({ id: entry.id, name: entry.name, mimeType: entry.mimeType, size: Number(entry.size || 0) });
          }
        }
        pageToken = payload.nextPageToken || '';
      } while (pageToken);
    }

    async function googleRecordsForDocuments(documents) {
      var records = [];
      var seenFolders = new Set();
      var seenFiles = new Set();
      for (var index = 0; index < documents.length; index++) {
        var documentObject = documents[index];
        var id = googleDocumentValue(documentObject, window.google.picker.Document.ID, 'id');
        var name = googleDocumentValue(documentObject, window.google.picker.Document.NAME, 'name');
        var mimeType = googleDocumentValue(documentObject, window.google.picker.Document.MIME_TYPE, 'mimeType');
        if (mimeType === 'application/vnd.google-apps.folder') {
          await googleListFolder(id, records, seenFolders, seenFiles);
        } else if ((mimeType === 'image/png' || mimeType === 'image/jpeg') && !seenFiles.has(id)) {
          seenFiles.add(id);
          records.push({ id: id, name: name, mimeType: mimeType, size: 0 });
        }
      }
      return records;
    }

    async function downloadGoogleRecord(record) {
      var response = await fetch('https://www.googleapis.com/drive/v3/files/' + encodeURIComponent(record.id) + '?alt=media&supportsAllDrives=true', {
        headers: { Authorization: 'Bearer ' + googleAccessToken },
      });
      if (!response.ok) throw new Error('Google Drive could not download ' + record.name + '.');
      var blob = await response.blob();
      return new File([blob], record.name, { type: record.mimeType || blob.type });
    }

    async function chooseGoogleDrive() {
      if (!googleClientId || !googleApiKey || !googleAppId) {
        setCloudStatus('Google Drive is not configured yet. Add its client ID, API key, and project number in Theme settings → Cloud image imports.', true);
        return;
      }
      setCloudProvider('google');
      setCloudBusy(true);
      setCloudStatus('Opening Google Drive…', false);
      try {
        await prepareGoogleLibraries();
        var token = await requestGoogleAccessToken();
        setCloudBusy(false);
        var documents = await showGooglePicker(token);
        if (!documents.length) {
          showCloudProviders('No Google Drive images were selected.', false);
          return;
        }
        setCloudBusy(true);
        setCloudStatus('Reading the selected Google Drive items…', false);
        var records = await googleRecordsForDocuments(documents);
        await importCloudRecords(records, downloadGoogleRecord, 'Google Drive');
      } catch (error) {
        showCloudProviders(error.message || 'Google Drive import failed.', true);
      }
    }

    function randomUrlToken(byteLength) {
      var bytes = new Uint8Array(byteLength);
      window.crypto.getRandomValues(bytes);
      var binary = '';
      bytes.forEach(function (value) { binary += String.fromCharCode(value); });
      return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
    }

    async function pkceChallenge(verifier) {
      var digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
      var binary = '';
      new Uint8Array(digest).forEach(function (value) { binary += String.fromCharCode(value); });
      return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
    }

    function dropboxRedirectUri() {
      var url = new URL('/', location.origin);
      url.searchParams.set('trc_dropbox_oauth', '1');
      return url.toString();
    }

    async function beginDropboxSignIn() {
      if (!dropboxAppKey) {
        setCloudStatus('Dropbox is not configured yet. Add its app key in Theme settings → Cloud image imports.', true);
        return;
      }
      if (!window.crypto || !window.crypto.subtle) {
        setCloudStatus('This browser cannot securely start Dropbox sign-in.', true);
        return;
      }
      setCloudProvider('dropbox');
      // If sign-in ends up in a separate tab, theme.js links back to this deck.
      try { window.localStorage.setItem('trc-dropbox-return', location.href); } catch (_) {}
      dropboxOauthPopup = window.open('about:blank', 'trc-dropbox-' + randomUrlToken(8), 'popup,width=720,height=760');
      if (!dropboxOauthPopup) {
        showCloudProviders('Allow pop-ups for this site, then try Dropbox again.', true);
        return;
      }
      setCloudBusy(true);
      setCloudStatus('Opening Dropbox sign-in…', false);
      try {
        dropboxOauthState = randomUrlToken(24);
        dropboxCodeVerifier = randomUrlToken(64);
        var challenge = await pkceChallenge(dropboxCodeVerifier);
        var url = new URL('https://www.dropbox.com/oauth2/authorize');
        url.searchParams.set('client_id', dropboxAppKey);
        url.searchParams.set('response_type', 'code');
        url.searchParams.set('redirect_uri', dropboxRedirectUri());
        url.searchParams.set('code_challenge', challenge);
        url.searchParams.set('code_challenge_method', 'S256');
        url.searchParams.set('token_access_type', 'online');
        url.searchParams.set('state', dropboxOauthState);
        dropboxOauthPopup.location.replace(url.toString());
        if (dropboxPopupPoll) window.clearInterval(dropboxPopupPoll);
        dropboxPopupPoll = window.setInterval(function () {
          if (dropboxOauthPopup && !dropboxOauthPopup.closed) return;
          window.clearInterval(dropboxPopupPoll);
          dropboxPopupPoll = null;
          dropboxOauthPopup = null;
          if (!dropboxOauthState) return;
          dropboxOauthState = '';
          dropboxCodeVerifier = '';
          showCloudProviders('Dropbox sign-in was closed before it finished.', true);
        }, 500);
      } catch (error) {
        if (dropboxPopupPoll) window.clearInterval(dropboxPopupPoll);
        dropboxPopupPoll = null;
        if (dropboxOauthPopup && !dropboxOauthPopup.closed) dropboxOauthPopup.close();
        dropboxOauthPopup = null;
        showCloudProviders('Dropbox sign-in could not be started.', true);
      }
    }

    async function exchangeDropboxCode(code) {
      var body = new URLSearchParams();
      body.set('code', code);
      body.set('grant_type', 'authorization_code');
      body.set('client_id', dropboxAppKey);
      body.set('redirect_uri', dropboxRedirectUri());
      body.set('code_verifier', dropboxCodeVerifier);
      var response = await fetch('https://api.dropboxapi.com/oauth2/token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (!response.ok) throw new Error('Dropbox sign-in could not be completed.');
      var payload = await response.json();
      if (!payload.access_token) throw new Error('Dropbox did not return an access token.');
      dropboxAccessToken = payload.access_token;
    }

    async function dropboxApi(endpoint, body) {
      var response = await fetch('https://api.dropboxapi.com/2/' + endpoint, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + dropboxAccessToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body || {}),
      });
      if (!response.ok) throw new Error('Dropbox could not read that folder.');
      return response.json();
    }

    async function dropboxListAll(path, recursive) {
      var payload = await dropboxApi('files/list_folder', {
        path: path || '',
        recursive: !!recursive,
        include_deleted: false,
        include_non_downloadable_files: false,
        limit: 2000,
      });
      var entries = payload.entries || [];
      while (payload.has_more) {
        payload = await dropboxApi('files/list_folder/continue', { cursor: payload.cursor });
        entries = entries.concat(payload.entries || []);
      }
      return entries;
    }

    function dropboxImageEntry(entry) {
      return entry && entry['.tag'] === 'file' && /\.(?:png|jpe?g)$/i.test(entry.name || '');
    }

    function renderDropboxEntries() {
      if (!dropboxEntriesEl || !dropboxBrowser) return;
      setCloudProvider('dropbox');
      dropboxEntriesEl.innerHTML = '';
      var visible = dropboxEntries.filter(function (entry) {
        return entry['.tag'] === 'folder' || dropboxImageEntry(entry);
      }).sort(function (left, right) {
        if (left['.tag'] !== right['.tag']) return left['.tag'] === 'folder' ? -1 : 1;
        return String(left.name).localeCompare(String(right.name), undefined, { numeric: true, sensitivity: 'base' });
      });
      visible.forEach(function (entry) {
        var row = document.createElement('div');
        row.className = 'trc-deck-editor__cloud-entry';
        var checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.checked = dropboxSelectedEntries.has(entry.path_lower);
        checkbox.setAttribute('aria-label', 'Select ' + (entry['.tag'] === 'folder' ? 'folder ' : '') + entry.name);
        checkbox.addEventListener('change', function () {
          if (checkbox.checked) dropboxSelectedEntries.set(entry.path_lower, entry);
          else dropboxSelectedEntries.delete(entry.path_lower);
          setCloudBusy(false);
        });
        row.appendChild(checkbox);
        var entryIcon = document.createElement('span');
        entryIcon.textContent = entry['.tag'] === 'folder' ? '📁' : '🖼️';
        entryIcon.setAttribute('aria-hidden', 'true');
        row.appendChild(entryIcon);
        var name = document.createElement('span');
        name.className = 'trc-deck-editor__cloud-entry-name';
        name.textContent = entry.name;
        row.appendChild(name);
        if (entry['.tag'] === 'folder') {
          var openButton = document.createElement('button');
          openButton.type = 'button';
          openButton.className = 'trc-deck-editor__cloud-entry-open';
          openButton.textContent = 'Open';
          openButton.addEventListener('click', function () { openDropboxFolder(entry); });
          row.appendChild(openButton);
        } else {
          var size = document.createElement('span');
          size.textContent = entry.size ? Math.max(1, Math.round(entry.size / 1024)) + ' KB' : '';
          row.appendChild(size);
        }
        dropboxEntriesEl.appendChild(row);
      });
      if (!visible.length) {
        var empty = document.createElement('p');
        empty.className = 'trc-deck-editor__cloud-empty';
        empty.textContent = 'No PNG or JPG images are in this folder.';
        dropboxEntriesEl.appendChild(empty);
      }
      if (dropboxPathEl) dropboxPathEl.textContent = dropboxPathStack.length
        ? 'Dropbox / ' + dropboxPathStack.map(function (entry) { return entry.name; }).join(' / ')
        : 'Dropbox';
      if (dropboxUpButton) {
        dropboxUpButton.disabled = cloudBusy;
        dropboxUpButton.setAttribute('aria-label', dropboxPathStack.length ? 'Go to parent folder' : 'Back to cloud sources');
      }
      if (dropboxSelectedButton) dropboxSelectedButton.disabled = cloudBusy || dropboxSelectedEntries.size === 0;
      dropboxBrowser.hidden = false;
    }

    async function loadDropboxFolder(path) {
      setCloudBusy(true);
      setCloudStatus('Loading Dropbox folder…', false);
      try {
        dropboxEntries = await dropboxListAll(path, false);
        dropboxPath = path || '';
        setCloudBusy(false);
        renderDropboxEntries();
        setCloudStatus('Choose images, open a folder, or import the current folder.', false);
      } catch (error) {
        setCloudBusy(false);
        setCloudStatus(error.message || 'Dropbox folder could not be loaded.', true);
      }
    }

    function openDropboxFolder(entry) {
      dropboxPathStack.push({ name: entry.name, path: entry.path_lower });
      loadDropboxFolder(entry.path_lower);
    }

    async function onDropboxOauthMessage(event) {
      if (event.origin !== location.origin || event.source !== dropboxOauthPopup) return;
      var data = event.data || {};
      if (data.type !== 'trc-dropbox-oauth' || data.state !== dropboxOauthState) return;
      if (dropboxPopupPoll) window.clearInterval(dropboxPopupPoll);
      dropboxPopupPoll = null;
      if (dropboxOauthPopup && !dropboxOauthPopup.closed) dropboxOauthPopup.close();
      dropboxOauthPopup = null;
      if (data.error || !data.code) {
        showCloudProviders(data.errorDescription || 'Dropbox sign-in was not completed.', true);
        return;
      }
      setCloudStatus('Finishing Dropbox sign-in…', false);
      try {
        await exchangeDropboxCode(data.code);
        dropboxPathStack = [];
        dropboxSelectedEntries.clear();
        await loadDropboxFolder('');
      } catch (error) {
        showCloudProviders(error.message || 'Dropbox sign-in failed.', true);
      } finally {
        dropboxCodeVerifier = '';
        dropboxOauthState = '';
      }
    }

    async function downloadDropboxRecord(record) {
      var response = await fetch('https://content.dropboxapi.com/2/files/download', {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + dropboxAccessToken,
          'Dropbox-API-Arg': JSON.stringify({ path: record.path_lower }),
        },
      });
      if (!response.ok) throw new Error('Dropbox could not download ' + record.name + '.');
      var blob = await response.blob();
      return new File([blob], record.name, { type: contentType({ name: record.name, type: blob.type }) });
    }

    async function importCloudRecords(records, downloadRecord, providerName) {
      var supported = (records || []).filter(function (record) {
        return /\.(?:png|jpe?g)$/i.test(record.name || '') || record.mimeType === 'image/png' || record.mimeType === 'image/jpeg';
      });
      if (!supported.length) {
        setCloudBusy(false);
        setCloudStatus('No PNG or JPG images were found in that selection.', true);
        return;
      }
      var tooLarge = 0;
      var failedDownload = 0;
      var files = [];
      setCloudBusy(true);
      for (var index = 0; index < supported.length; index++) {
        var record = supported[index];
        setCloudStatus('Downloading ' + (index + 1) + ' of ' + supported.length + ' from ' + providerName + '…', false);
        if (Number(record.size || 0) > 50 * 1024 * 1024) {
          tooLarge++;
          continue;
        }
        try {
          var file = await downloadRecord(record);
          if (file.size > 50 * 1024 * 1024) tooLarge++;
          else if (file.size && contentType(file)) files.push(file);
          else failedDownload++;
        } catch (error) {
          failedDownload++;
        }
      }
      var added = false;
      if (files.length) added = await addFiles(files, { autofill: false });
      var failedTotal = tooLarge + failedDownload;
      if (failedTotal) {
        var reasons = [];
        if (tooLarge) reasons.push(tooLarge + ' exceeded the 50 MB limit');
        if (failedDownload) reasons.push(failedDownload + ' could not be downloaded');
        fileError = failedTotal + ' file' + (failedTotal === 1 ? '' : 's') + ' failed to import: ' + reasons.join('; ') + '.';
        render();
        emitChange();
      }
      setCloudBusy(false);
      if (added && files.length) closeCloudImport(false);
      else setCloudStatus(fileError || 'No images were imported.', true);
    }

    async function importDropboxSelection() {
      var selected = Array.from(dropboxSelectedEntries.values());
      if (!selected.length) return;
      setCloudBusy(true);
      setCloudStatus('Reading the selected Dropbox items…', false);
      try {
        var records = [];
        var seenPaths = new Set();
        function addRecord(record) {
          if (!dropboxImageEntry(record) || seenPaths.has(record.path_lower)) return;
          seenPaths.add(record.path_lower);
          records.push(record);
        }
        for (var index = 0; index < selected.length; index++) {
          var entry = selected[index];
          if (entry['.tag'] === 'folder') {
            (await dropboxListAll(entry.path_lower, true)).forEach(addRecord);
          } else {
            addRecord(entry);
          }
        }
        await importCloudRecords(records, downloadDropboxRecord, 'Dropbox');
      } catch (error) {
        setCloudBusy(false);
        setCloudStatus(error.message || 'The selected Dropbox items could not be imported.', true);
      }
    }

    async function importDropboxFolder() {
      setCloudBusy(true);
      setCloudStatus('Reading every image in this Dropbox folder…', false);
      try {
        var records = (await dropboxListAll(dropboxPath, true)).filter(dropboxImageEntry);
        await importCloudRecords(records, downloadDropboxRecord, 'Dropbox');
      } catch (error) {
        setCloudBusy(false);
        setCloudStatus(error.message || 'Dropbox folder import failed.', true);
      }
    }

    function confirmImageAssignment() {
      var item = itemById(assignmentItemId);
      var slotIndex = Number(assignmentSlot && assignmentSlot.value);
      if (!item || !assignmentSlotAllowed(slotIndex, assignmentSide)) return;
      if (slots[slotIndex][assignmentSide] !== item.id) {
        rememberForUndo();
        assign(slotIndex, assignmentSide, item.id);
        emptyCloseAttempted = false;
      }
      closeImageAssignment(false);
      render();
      emitChange();
    }

    function addFiles(fileList, settings) {
      var files = Array.from(fileList || []);
      var capacityFiles = files.filter(function (file) {
        return !!contentType(file) && !!file.size && file.size <= 50 * 1024 * 1024;
      });
      if (!navigator.storage || typeof navigator.storage.estimate !== 'function') {
        addFilesNow(files, settings);
        return Promise.resolve(true);
      }
      return storageCapacityFor(capacityFiles).then(function (hasCapacity) {
        if (!hasCapacity) {
          fileError = 'These images exceed the browser storage available for autosave. Choose fewer or smaller files.';
          render();
          emitChange();
          return false;
        }
        addFilesNow(files, settings);
        return true;
      });
    }

    function addFilesNow(fileList, settings) {
      settings = settings || {};
      fileError = '';
      var added = [];
      var rejectedType = 0;
      var rejectedSize = 0;
      var rejectedEmpty = 0;
      var historyRemembered = false;
      Array.from(fileList || []).forEach(function (file) {
        if (!contentType(file)) {
          if (!settings.ignoreUnsupported) rejectedType++;
          return;
        }
        if (!file.size) {
          rejectedEmpty++;
          return;
        }
        if (file.size > 50 * 1024 * 1024) {
          rejectedSize++;
          return;
        }
        if (!historyRemembered) {
          rememberForUndo();
          historyRemembered = true;
        }
        var item = {
          id: itemId(),
          file: file,
          url: URL.createObjectURL(file),
          previewUrl: '',
          width: 0,
          height: 0,
          resolutionState: 'checking',
        };
        items.push(item);
        added.push(item);
      });
      if (added.length) {
        var completedInspections = 0;
        added.forEach(function (item) {
          inspectResolution(item, function () {
            completedInspections++;
            if (completedInspections === added.length || completedInspections % 8 === 0) scheduleRefresh();
          }, { deferRefresh: true });
        });
      }
      var rejectedTotal = rejectedType + rejectedSize + rejectedEmpty;
      if (rejectedTotal) {
        var reasons = [];
        if (rejectedSize) reasons.push(rejectedSize + ' exceeded the 50 MB limit');
        if (rejectedType) reasons.push(rejectedType + ' ' + (rejectedType === 1 ? 'was' : 'were') + ' not PNG or JPG');
        if (rejectedEmpty) reasons.push(rejectedEmpty + ' ' + (rejectedEmpty === 1 ? 'was empty' : 'were empty'));
        fileError = rejectedTotal + ' file' + (rejectedTotal === 1 ? '' : 's') + ' failed to upload: ' + reasons.join('; ') + '.';
      }
      if (settings.target && added.length) {
        assign(settings.target.slot, settings.target.side, added[0].id);
      } else if (settings.autofill !== false) {
        autoFillFronts(added);
      }
      if (added.length) emptyCloseAttempted = false;
      render();
      emitChange();
      return added;
    }

    function autoFillFronts(sourceItems) {
      var queue = (Array.isArray(sourceItems) ? sourceItems : items).filter(function (item) {
        return usage(item.id) === 0;
      });
      for (var slotIndex = 0; slotIndex < slots.length && queue.length; slotIndex++) {
        if (!slots[slotIndex].front) slots[slotIndex].front = queue.shift().id;
      }
    }

    function assign(slotIndex, side, itemId) {
      if (!slots[slotIndex] || !itemById(itemId)) return;
      slots[slotIndex][side] = itemId;
    }

    function clearFace(slotIndex, side) {
      if (!slots[slotIndex] || !slots[slotIndex][side]) return;
      rememberForUndo();
      slots[slotIndex][side] = null;
      render();
      emitChange();
    }

    function usage(itemId) {
      if (renderUsageLookup) return renderUsageLookup.get(itemId) || 0;
      return slots.reduce(function (count, slot) {
        return count + (slot.front === itemId ? 1 : 0) + (slot.back === itemId ? 1 : 0);
      }, 0);
    }

    function removeItem(itemId) {
      if (!itemById(itemId)) return;
      rememberForUndo();
      slots.forEach(function (slot) {
        if (slot.front === itemId) slot.front = null;
        if (slot.back === itemId) slot.back = null;
      });
      var item = itemById(itemId);
      items = items.filter(function (candidate) { return candidate.id !== itemId; });
      render();
      emitChange();
    }

    function clearLibrary() {
      if (!items.length) return;
      rememberForUndo();
      items = [];
      slots = [];
      hiddenSlots = [];
      makeSlots(maximum);
      fileError = '';
      emptyCloseAttempted = false;
      libraryFilter = 'unused';
      bulkInput.value = '';
      render();
      emitChange();
    }

    function closeLibraryActionMenu(restoreFocus) {
      if (!libraryActionMenu || !libraryActionMenu.open) return;
      libraryActionMenu.open = false;
      if (restoreFocus) {
        var summary = libraryActionMenu.querySelector('summary');
        if (summary) summary.focus();
      }
    }

    function frontCount() {
      return filledSlots().length;
    }

    function filledSlots() {
      return slots.filter(function (slot) { return !!slot.front; });
    }

    function lowResolutionSlots() {
      var result = [];
      slots.forEach(function (slot, index) {
        var low = [slot.front, slot.back].some(function (id) {
          var item = id && itemById(id);
          return item && item.resolutionState === 'ready' && !resolutionValid(item);
        });
        if (low) result.push(index + 1);
      });
      return result;
    }

    function validation() {
      var count = frontCount();
      if (fileError && !count) return { valid: false, message: fileError };
      if (count < minimum || count > maximum) {
        return {
          valid: false,
          message: count
            ? ('This product has ' + maximum + ' slots.')
            : (emptyCloseAttempted ? (items.length ? 'Place your uploaded images into card slots in the deck editor.' : 'Upload images in the deck editor.') : ''),
        };
      }
      for (var index = 0; index < slots.length; index++) {
        if (slots[index].back && !slots[index].front) {
          return { valid: false, message: 'Slot ' + (index + 1) + ' needs a front before it can use a custom back.' };
        }
      }
      var totalBytes = planFiles().reduce(function (sum, item) {
        return sum + Number(item.file.size || 0);
      }, 0);
      if (totalBytes > 8 * 1024 * 1024 * 1024) {
        return { valid: false, message: 'This deck is larger than the 8 GB upload limit.' };
      }
      var usedItems = planFiles();
      var checking = usedItems.find(function (item) { return item.resolutionState === 'checking'; });
      if (checking) return { valid: false, message: 'Checking image resolution…' };
      var unreadable = usedItems.find(function (item) { return item.resolutionState === 'error'; });
      if (unreadable) return { valid: false, message: 'Could not read ' + unreadable.file.name + '. Try a different PNG or JPG.' };
      var oversize = usedItems.find(function (item) { return item.resolutionState === 'oversize'; });
      if (oversize) {
        return {
          valid: false,
          message: oversize.file.name + ' is too large to print (' + oversize.width + ' × ' + oversize.height + ' px). ' +
            'Remove it or replace it with a copy no wider or taller than 20,000 px and under 100 megapixels.',
        };
      }
      var remaining = maximum - count;
      if (options.exactQuantity && remaining > 0) return {valid:false,incomplete:true,missing:remaining,message:count + " of " + maximum + " cards filled."};
      var missingText = remaining ? ' · ' + remaining + ' empty.' : '';
      if (fileError) return { valid: true, warning: true, message: fileError + missingText };
      // Draft recovery is optional; the upload queue must save its own files before the form clears this deck.
      if (autosaveError) return { valid: true, warning: true, message: autosaveError };
      var lowSlots = lowResolutionSlots();
      if (lowSlots.length) return {
        valid: true,
        warning: true,
        message: 'Low resolution warning for slot' + (lowSlots.length === 1 ? ' ' : 's ') + lowSlots.join(', ') + '. You can continue, but print quality may be reduced.' + missingText,
      };
      return {
        valid: true,
        warning: remaining > 0,
        incomplete: remaining > 0,
        missing: remaining,
        message: count + ' of ' + maximum + ' slots filled' + (remaining ? ' · ' + remaining + ' missing' : '') + '.',
      };
    }

    function stopDragAutoScroll() {
      autoScrollVelocity = 0;
      if (autoScrollFrame === null) return;
      if (typeof window.cancelAnimationFrame === 'function') window.cancelAnimationFrame(autoScrollFrame);
      else window.clearTimeout(autoScrollFrame);
      autoScrollFrame = null;
    }

    function dragAutoScrollTick() {
      if (!workspace || !autoScrollVelocity) {
        autoScrollFrame = null;
        return;
      }
      workspace.scrollTop += autoScrollVelocity;
      var schedule = window.requestAnimationFrame || function (callback) { return window.setTimeout(callback, 16); };
      autoScrollFrame = schedule(dragAutoScrollTick);
    }

    function editorImageDrag(event) {
      if (activeSlotDrag || draggedLibraryImage || defaultBackDragPreview) return true;
      if (!event.dataTransfer) return false;
      var types = Array.from(event.dataTransfer.types || []);
      return types.some(function (type) {
        return type === 'application/x-trc-image' ||
          type === 'application/x-trc-slot-image' ||
          type === 'application/x-trc-default-back';
      });
    }

    function updateDragAutoScroll(event) {
      if (!workspace || !dialog || !editorImageDrag(event)) {
        stopDragAutoScroll();
        return;
      }
      var rect = dialog.getBoundingClientRect();
      var threshold = Math.min(110, Math.max(64, rect.height * .14));
      var pointerY = Number(event.clientY || 0);
      var nextVelocity = 0;
      if (pointerY < rect.top + threshold) {
        nextVelocity = -Math.ceil(4 + ((rect.top + threshold - pointerY) / threshold) * 18);
      } else if (pointerY > rect.bottom - threshold) {
        nextVelocity = Math.ceil(4 + ((pointerY - (rect.bottom - threshold)) / threshold) * 18);
      }
      autoScrollVelocity = nextVelocity;
      if (!nextVelocity) {
        stopDragAutoScroll();
      } else if (autoScrollFrame === null) {
        var schedule = window.requestAnimationFrame || function (callback) { return window.setTimeout(callback, 16); };
        autoScrollFrame = schedule(dragAutoScrollTick);
      }
    }

    function planFiles() {
      var ids = [];
      filledSlots().forEach(function (slot) {
        [slot.front, slot.back].forEach(function (id) {
          if (id && ids.indexOf(id) === -1) ids.push(id);
        });
      });
      return ids.map(itemById).filter(Boolean);
    }

    function plan() {
      var compactSlots = filledSlots();
      var count = compactSlots.length;
      var usedItems = planFiles();
      var usedIds = usedItems.map(function (item) { return item.id; });
      var indexById = {};
      usedIds.forEach(function (id, index) { indexById[id] = index; });
      return {
        valid: validation().valid,
        count: count,
        selectedCount: maximum,
        previewCards: compactSlots.reduce(function (cards, slot) {
          var item = itemById(slot.front);
          if (!item) return cards;
          var existing = cards.find(function (card) { return card.id === item.id; });
          if (existing) existing.quantity++;
          else cards.push({id: item.id, name: item.file.name, quantity: 1, thumbnailUrl: itemDisplayUrl(item)});
          return cards;
        }, []),
        files: usedItems.map(function (item) { return item.file; }),
        slots: compactSlots.map(function (slot, index) {
          return {
            index: index + 1,
            frontFileIndex: indexById[slot.front],
            backFileIndex: slot.back ? indexById[slot.back] : null,
          };
        }),
        totalLibraryFiles: items.length,
        hasDraft: items.length > 0 || !!defaultBackFile || slots.some(function (slot) {
          return !!slot.front || !!slot.back;
        }),
      };
    }

    function faceButton(slotIndex, side) {
      var id = slots[slotIndex][side];
      var item = id ? itemById(id) : null;
      var button = document.createElement('div');
      button.className = 'trc-deck-editor__face';
      button.dataset.slot = String(slotIndex);
      button.dataset.side = side;
      button.setAttribute('data-trc-native-touch', '');
      button.tabIndex = 0;
      button.setAttribute('role', 'button');
      button.setAttribute('aria-label', 'Choose slot ' + (slotIndex + 1) + ' ' + side + ' image');

      if (item) {
        button.classList.add('has-image');
        button.draggable = true;
        button.addEventListener('dragstart', function (event) {
          activeSlotDrag = { slot: slotIndex, side: side, itemId: item.id };
          draggedSlotCard = button.closest('.trc-deck-editor__slot');
          event.dataTransfer.setData('application/x-trc-slot-image', JSON.stringify(activeSlotDrag));
          event.dataTransfer.effectAllowed = 'move';
          button.classList.add('is-dragging');
        });
        button.addEventListener('dragend', function () {
          activeSlotDrag = null;
          button.classList.remove('is-dragging');
          document.querySelectorAll('.trc-deck-editor__face.is-dragover').forEach(function (face) {
            face.classList.remove('is-dragover');
          });
        });
        var image = document.createElement('img');
        image.src = itemDisplayUrl(item);
        image.alt = item.file.name;
        image.loading = 'lazy';
        image.decoding = 'async';
        applyPrintCrop(image);
        button.appendChild(image);
        if (item.resolutionState === 'ready' && !resolutionValid(item)) {
          button.classList.add('is-resolution-error');
          var warning = document.createElement('span');
          warning.className = 'trc-deck-editor__resolution-warning';
          warning.textContent = '!';
          warning.title = item.width + ' × ' + item.height + ' px (recommended minimum ' + minImageWidth + ' × ' + minImageHeight + ' px)';
          button.appendChild(warning);
        }
        var clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'trc-deck-editor__face-clear';
        clear.setAttribute('aria-label', side === 'back' ? 'Use default back' : 'Clear front');
        clear.title = side === 'back' ? 'Use default back' : 'Clear front';
        clear.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          clearFace(slotIndex, side);
        });
        button.appendChild(clear);
      } else if (side === 'back') {
        button.classList.add('has-image');
        var defaultImage = document.createElement('img');
        defaultImage.src = currentDefaultBack();
        defaultImage.alt = 'Selected card back';
        defaultImage.loading = 'lazy';
        defaultImage.decoding = 'async';
        button.appendChild(defaultImage);
      } else {
        var placeholder = document.createElement('span');
        placeholder.className = 'trc-deck-editor__face-placeholder';
        placeholder.innerHTML = '<b>+</b><span>Add front</span>';
        button.appendChild(placeholder);
      }

      button.addEventListener('click', function () {
        pickTarget = { slot: slotIndex, side: side };
        slotInput.value = '';
        slotInput.click();
      });
      button.addEventListener('keydown', function (event) {
        if (event.target !== button || (event.key !== 'Enter' && event.key !== ' ')) return;
        event.preventDefault();
        button.click();
      });
      function acceptsImageDrag(event) {
        if (!event.dataTransfer) return false;
        if (activeSlotDrag) return true;
        if (event.dataTransfer.files && event.dataTransfer.files.length) return true;
        var types = Array.from(event.dataTransfer.types || []);
        if (types.indexOf('Files') !== -1 || types.indexOf('application/x-trc-image') !== -1) return true;
        if (types.indexOf('application/x-trc-default-back') !== -1) return side === 'back';
        if (types.indexOf('application/x-trc-slot-image') !== -1) {
          return true;
        }
        return false;
      }
      function showDropTarget(event) {
        if (!acceptsImageDrag(event)) return;
        event.preventDefault();
        if (event.dataTransfer) {
          event.dataTransfer.dropEffect = activeSlotDrag ? 'move' : 'copy';
        }
        button.classList.add('is-dragover');
      }
      button.addEventListener('dragenter', showDropTarget);
      button.addEventListener('dragover', showDropTarget);
      button.addEventListener('dragleave', function (event) {
        if (event.relatedTarget && button.contains(event.relatedTarget)) return;
        button.classList.remove('is-dragover');
      });
      button.addEventListener('drop', function (event) {
        if (!acceptsImageDrag(event)) return;
        event.preventDefault();
        button.classList.remove('is-dragover');
        var slotPayload = typeof event.dataTransfer.getData === 'function'
          ? event.dataTransfer.getData('application/x-trc-slot-image')
          : '';
        var source = activeSlotDrag;
        if (!source && slotPayload) {
          try {
            source = JSON.parse(slotPayload);
          } catch (ignore) {}
        }
        if (source) {
          var sourceSlot = slots[source.slot];
          var sourceIsCurrent = sourceSlot && sourceSlot[source.side] === source.itemId;
          var sameFace = source.slot === slotIndex && source.side === side;
          if (sourceIsCurrent && !sameFace) {
            rememberForUndo();
            var replacedItem = slots[slotIndex][side] || null;
            slots[slotIndex][side] = source.itemId;
            sourceSlot[source.side] = replacedItem;
            activeSlotDrag = null; draggedSlotCard = null;
            render();
            emitChange();
          }
          activeSlotDrag = null;
          return;
        }
        var defaultBackPayload = typeof event.dataTransfer.getData === 'function'
          ? event.dataTransfer.getData('application/x-trc-default-back')
          : '';
        if (defaultBackPayload && side === 'back') {
          if (slots[slotIndex].back) {
            rememberForUndo();
            slots[slotIndex].back = null;
            render();
            emitChange();
          }
          return;
        }
        var itemId = typeof event.dataTransfer.getData === 'function'
          ? event.dataTransfer.getData('application/x-trc-image')
          : '';
        if (itemId) {
          if (slots[slotIndex][side] === itemId) return;
          rememberForUndo();
          assign(slotIndex, side, itemId);
          render();
          emitChange();
        } else if (event.dataTransfer.files && event.dataTransfer.files.length) {
          addFiles(event.dataTransfer.files, { target: { slot: slotIndex, side: side } });
        }
      });
      return button;
    }

    function currentDefaultBack() {
      var selected = document.querySelector('[data-cardback-img="images"]');
      return (selected && selected.src) || defaultBackEl.src;
    }

    function clearDefaultBackDragPreview() {
      if (defaultBackDragPreview && defaultBackDragPreview.parentNode) defaultBackDragPreview.remove();
      defaultBackDragPreview = null;
      if (defaultBackEl) defaultBackEl.classList.remove('is-dragging');
    }

    function setDefaultBackDragPreview(event) {
      clearDefaultBackDragPreview();
      if (!defaultBackEl) return;
      var preview = document.createElement('span');
      preview.className = 'trc-deck-editor__default-back-drag-preview';
      var image = defaultBackEl.cloneNode(true);
      image.removeAttribute('id');
      image.alt = '';
      preview.appendChild(image);
      document.body.appendChild(preview);
      defaultBackDragPreview = preview;
      defaultBackEl.classList.add('is-dragging');
      if (event.dataTransfer && typeof event.dataTransfer.setDragImage === 'function') {
        event.dataTransfer.setDragImage(preview, 55, 77);
      }
    }

    function hasCustomDefaultBack() {
      var selected = document.querySelector('[data-cardback-img="images"]');
      if (!selected || !selected.src) return false;
      var standard = selected.getAttribute('data-cardback-default') || '';
      try { standard = new URL(standard, document.baseURI).href; } catch (ignore) {}
      return selected.src !== standard;
    }

    function renderSlots() {
      var fragment = document.createDocumentFragment();
      var viewMode = viewEl ? viewEl.value : 'both';
      var slotFilter = slotFilterEl ? slotFilterEl.value : 'all';
      var matching = [];
      slots.forEach(function (slot, index) {
        if ((slotFilter === 'empty' && slot.front) || (slotFilter === 'filled' && !slot.front)) return;
        matching.push(index);
      });
      if (previousSlotFilter !== slotFilter) { slotPage = 0; previousSlotFilter = slotFilter; }
      var pageCount = Math.max(1, Math.ceil(matching.length / slotPageSize));
      slotPage = Math.max(0, Math.min(slotPage, pageCount - 1));
      slotPages.hidden = pageCount === 1;
      slotPageSummary.textContent = 'Page ' + (slotPage + 1) + ' of ' + pageCount;
      previousSlotPage.disabled = slotPage === 0;
      nextSlotPage.disabled = slotPage === pageCount - 1;
      if (slotPageNumbers.children.length !== pageCount) {
        slotPageNumbers.replaceChildren();
        for (var page = 0; page < pageCount; page++) {
          var button = document.createElement('button');
          button.type = 'button'; button.textContent = String(page + 1);
          button.dataset.slotPage = String(page);
          button.setAttribute('aria-label', 'Page ' + (page + 1));
          slotPageNumbers.appendChild(button);
        }
      }
      Array.from(slotPageNumbers.children).forEach(function (button, page) {
        if (page === slotPage) button.setAttribute('aria-current', 'page');
        else button.removeAttribute('aria-current');
        var first = matching[page * slotPageSize];
        var last = matching[Math.min((page + 1) * slotPageSize, matching.length) - 1];
        button.title = 'Slots ' + (first + 1) + ' to ' + (last + 1) + ' of ' + maximum;
      });
      if (editorFooter) editorFooter.classList.toggle('has-slot-pages', pageCount > 1);
      var visibleCount = matching.length;
      matching.slice(slotPage * slotPageSize, (slotPage + 1) * slotPageSize).forEach(function (index) {
        var slot = slots[index];
        var card = document.createElement('article');
        card.className = 'trc-deck-editor__slot';
        var number = document.createElement('div');
        number.className = 'trc-deck-editor__slot-number';
        number.textContent = 'Slot ' + (index + 1);
        var lowResolution = [slot.front, slot.back].some(function (id) {
          var item = id && itemById(id);
          return item && item.resolutionState === 'ready' && !resolutionValid(item);
        });
        if (lowResolution) {
          var badge = document.createElement('span');
          badge.className = 'trc-deck-editor__slot-warning';
          badge.textContent = 'Low res';
          number.appendChild(badge);
        }
        card.appendChild(number);
        var faces = document.createElement('div');
        faces.className = 'trc-deck-editor__faces' + (viewMode === 'both' ? '' : ' is-single');
        function addFace(side) {
          var column = document.createElement('div');
          column.className = 'trc-deck-editor__face-column';
          column.appendChild(faceButton(index, side));
          var caption = document.createElement('span');
          caption.className = 'trc-deck-editor__face-caption';
          caption.textContent = side === 'front' ? 'Front' : 'Back';
          column.appendChild(caption);
          faces.appendChild(column);
        }
        if (viewMode !== 'back') addFace('front');
        if (viewMode !== 'front') addFace('back');
        card.appendChild(faces);
        fragment.appendChild(card);
      });
      if (!visibleCount) {
        var empty = document.createElement('p');
        empty.className = 'trc-deck-editor__slot-filter-empty';
        empty.textContent = slotFilter === 'filled' ? 'No filled slots yet.' : 'No empty slots.';
        fragment.appendChild(empty);
      }
      if (draggedSlotCard && draggedSlotCard.parentNode === slotsEl) {
        // Keep the native drag source attached; removing it cancels dragging
        // in browsers before the customer can drop on the destination page.
        draggedSlotCard.classList.add('is-drag-anchor');
        draggedSlotCard.setAttribute('aria-hidden', 'true');
        Array.from(slotsEl.children).forEach(function (child) {
          if (child !== draggedSlotCard) child.remove();
        });
        slotsEl.appendChild(fragment);
      } else slotsEl.replaceChildren(fragment);
    }

    function renderLibrary() {
      var fragment = document.createDocumentFragment();
      var usedCount = items.reduce(function (count, item) { return count + (usage(item.id) > 0 ? 1 : 0); }, 0);
      var unusedCount = items.length - usedCount;
      if (libraryFilterAllCount) libraryFilterAllCount.textContent = String(items.length);
      if (libraryFilterUsedCount) libraryFilterUsedCount.textContent = String(usedCount);
      if (libraryFilterUnusedCount) libraryFilterUnusedCount.textContent = String(unusedCount);
      libraryFilterButtons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.trcLibraryFilter === libraryFilter));
      });
      var visibleItems = items.filter(function (item) {
        var used = usage(item.id) > 0;
        return libraryFilter === 'all' || (libraryFilter === 'used' ? used : !used);
      });
      // An image used only as a card back shows without the foil sheen (fronts only).
      var frontIds = new Set();
      var backIds = new Set();
      slots.forEach(function (slot) {
        if (slot.front) frontIds.add(slot.front);
        if (slot.back) backIds.add(slot.back);
      });
      visibleItems.forEach(function (item) {
        var card = document.createElement('div');
        card.className = 'trc-deck-editor__image';
        card.tabIndex = 0;
        card.setAttribute('role', 'button');
        card.setAttribute('aria-label', 'Add ' + item.file.name + ' to a slot');
        if (item.resolutionState === 'ready' && !resolutionValid(item)) card.classList.add('is-resolution-error');
        card.draggable = true;
        card.title = item.resolutionState === 'ready' || item.resolutionState === 'oversize'
          ? item.width + ' × ' + item.height + ' px' + (item.resolutionState === 'oversize' ? ', too large to print' : '')
          : 'Checking resolution…';
        card.addEventListener('dragstart', function (event) {
          draggedLibraryImage = true;
          event.dataTransfer.setData('application/x-trc-image', item.id);
          event.dataTransfer.effectAllowed = 'copy';
        });
        card.addEventListener('dragend', function () {
          window.setTimeout(function () { draggedLibraryImage = false; }, 0);
        });
        card.addEventListener('click', function (event) {
          if (draggedLibraryImage || event.target.closest('.trc-deck-editor__image-remove')) return;
          openImageAssignment(item, card);
        });
        card.addEventListener('keydown', function (event) {
          if (event.target !== card || (event.key !== 'Enter' && event.key !== ' ')) return;
          event.preventDefault();
          openImageAssignment(item, card);
        });
        var image = document.createElement('img');
        image.src = itemDisplayUrl(item);
        image.alt = item.file.name;
        image.loading = 'lazy';
        image.decoding = 'async';
        applyPrintCrop(image);
        var preview = document.createElement('div');
        preview.className = 'trc-deck-editor__image-preview' + (backIds.has(item.id) && !frontIds.has(item.id) ? ' is-back' : '');
        preview.style.aspectRatio = '1 / ' + finishedRatio.toFixed(4);
        preview.appendChild(image);
        card.appendChild(preview);
        var used = document.createElement('span');
        used.className = 'trc-deck-editor__image-usage';
        used.textContent = usage(item.id) + '×';
        card.appendChild(used);
        var name = document.createElement('span');
        name.className = 'trc-deck-editor__image-name';
        name.textContent = item.file.name;
        card.appendChild(name);
        if (item.resolutionState === 'oversize') {
          card.classList.add('is-resolution-error');
          var oversizeLabel = document.createElement('span');
          oversizeLabel.className = 'trc-deck-editor__image-resolution';
          oversizeLabel.textContent = 'Too large to print';
          card.appendChild(oversizeLabel);
        } else if (item.resolutionState === 'ready' && !resolutionValid(item)) {
          var resolution = document.createElement('span');
          resolution.className = 'trc-deck-editor__image-resolution';
          resolution.textContent = 'Low resolution';
          card.appendChild(resolution);
        }
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'trc-deck-editor__image-remove';
        var removeIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        removeIcon.setAttribute('viewBox', '0 0 16 16');
        removeIcon.setAttribute('aria-hidden', 'true');
        var removePath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        removePath.setAttribute('d', 'M4 4l8 8M12 4l-8 8');
        removeIcon.appendChild(removePath);
        remove.appendChild(removeIcon);
        remove.setAttribute('aria-label', 'Remove ' + item.file.name);
        remove.title = 'Remove image';
        remove.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          removeItem(item.id);
        });
        card.appendChild(remove);
        fragment.appendChild(card);
      });
      if (!visibleItems.length) {
        var empty = document.createElement('p');
        empty.className = 'trc-deck-editor__library-empty';
        empty.textContent = items.length ? 'No cards match this filter.' : 'No images have been added yet.';
        fragment.appendChild(empty);
      }
      libraryEl.replaceChildren(fragment);
      libraryCount.textContent = items.length + ' image' + (items.length === 1 ? '' : 's');
      if (libraryOpenCount) libraryOpenCount.textContent = String(items.length);
    }

    function renderClosedPreview(animate) {
      if (!closedPreview) return;
      var previewItems = slots.map(function (slot) { return slot.front && itemById(slot.front); })
        .filter(Boolean)
        .slice(0, 3);
      closedPreview.innerHTML = '';
      closedPreview.hidden = !previewItems.length;
      closedPreview.classList.remove('is-entering');
      if (!previewItems.length) return;
      var layouts = previewItems.length === 1
        ? [{ x: 0, y: 0, rotate: 0, z: 1 }]
        : previewItems.length === 2
          ? [{ x: 0, y: 0, rotate: 0, z: 2 }, { x: 34, y: 10, rotate: 9, z: 1 }]
          : [{ x: 0, y: 0, rotate: 0, z: 3 }, { x: -43, y: 13, rotate: -11, z: 1 }, { x: 43, y: 13, rotate: 11, z: 2 }];
      previewItems.forEach(function (item, index) {
        var card = document.createElement('span');
        card.className = 'trc-deck-editor-closed-preview__card';
        card.style.setProperty('--trc-preview-x', layouts[index].x + 'px');
        card.style.setProperty('--trc-preview-y', layouts[index].y + 'px');
        card.style.setProperty('--trc-preview-rotation', layouts[index].rotate + 'deg');
        card.style.setProperty('--trc-preview-order', String(index));
        card.style.zIndex = String(layouts[index].z);
        var image = document.createElement('img');
        image.src = itemDisplayUrl(item);
        image.alt = item.file.name;
        image.loading = 'lazy';
        image.decoding = 'async';
        applyPrintCrop(image);
        card.appendChild(image);
        closedPreview.appendChild(card);
      });
      if (animate) {
        void closedPreview.offsetWidth;
        closedPreview.classList.add('is-entering');
      }
    }

    function applySlotSize() {
      var sizeMin = Number(sizeEl.min) || 112;
      var sizeMax = Number(sizeEl.max) || 260;
      var progress = Math.max(0, Math.min(100, (Number(sizeEl.value) - sizeMin) / (sizeMax - sizeMin) * 100));
      sizeEl.style.setProperty('--trc-slider-progress', progress + '%');
      if (dialog) {
        dialog.style.setProperty('--trc-slot-width', (sizeEl.value || 176) + 'px');
        if (supportsContainerUnits) dialog.style.setProperty('--trc-face-height', (finishedRatio * 100).toFixed(2) + 'cqw');
      }
    }

    // Browsers without container query units (Safari 15 and older, Samsung
    // Internet 19 and older) size each card face from the measured slot width.
    var faceSizeObserver = null;
    function syncFaceHeightFallback() {
      if (supportsContainerUnits || !dialog || !slotsEl) return;
      if (!faceSizeObserver && typeof ResizeObserver === 'function') {
        faceSizeObserver = new ResizeObserver(function () { syncFaceHeightFallback(); });
        faceSizeObserver.observe(slotsEl);
      }
      var slot = slotsEl.querySelector('.trc-deck-editor__slot');
      var width = slot ? slot.clientWidth : 0;
      if (!width) return;
      dialog.style.setProperty('--trc-face-px', (Math.max(0, width - 1) / 2 * finishedRatio).toFixed(2) + 'px');
      dialog.style.setProperty('--trc-face-px-single', (width * finishedRatio).toFixed(2) + 'px');
    }

    function render() {
      if (draggedSlotCard || draggedLibraryImage) { deferredDragRender = true; return; }
      prepareRenderLookups();
      try {
        applySlotSize();
        if (defaultBackEl) defaultBackEl.src = currentDefaultBack();
        if (resetBackButton) resetBackButton.hidden = !hasCustomDefaultBack();
        if (autofillButton) {
          var hasOpenFront = slots.some(function (slot) { return !slot.front; });
          var hasUnusedImage = items.some(function (item) { return usage(item.id) === 0; });
          autofillButton.disabled = !hasOpenFront || !hasUnusedImage;
        }
        if (resetSlotsButton) {
          resetSlotsButton.disabled = !slots.some(function (slot) { return !!slot.front || !!slot.back; });
        }
        if (clearLibraryButton) clearLibraryButton.disabled = !items.length;
        renderSlots();
        syncFaceHeightFallback();
        renderLibrary();
        if (modal.hidden) renderClosedPreview(false);
        var result = validation();
        filledEl.textContent = frontCount() + ' of ' + maximum;
        if (slotCountInput) slotCountInput.value = String(maximum);
        messageEl.textContent = result.message || 'Changes save automatically.';
        messageEl.classList.toggle('is-valid', result.valid && !result.warning);
        messageEl.classList.toggle('is-warning', !!result.warning);
        messageEl.classList.toggle('is-neutral', !result.message);
      } finally {
        clearRenderLookups();
      }
    }

    function notifyChange() {
      if (typeof options.onChange === 'function') options.onChange(plan(), validation());
    }

    function emitChange() {
      scheduleDraftSave();
      notifyChange();
    }

    function isolateBackground(active) {
      if (active) {
        backgroundState = Array.from(document.body.children).filter(function (element) { return element !== modal; }).map(function (element) {
          return { element: element, inert: element.inert, ariaHidden: element.getAttribute('aria-hidden') };
        });
        backgroundState.forEach(function (entry) {
          entry.element.inert = true;
          entry.element.setAttribute('aria-hidden', 'true');
        });
        return;
      }
      backgroundState.forEach(function (entry) {
        entry.element.inert = entry.inert;
        if (entry.ariaHidden === null) entry.element.removeAttribute('aria-hidden');
        else entry.element.setAttribute('aria-hidden', entry.ariaHidden);
      });
      backgroundState = [];
    }

    function open() {
      lastFocus = document.activeElement;
      emptyCloseAttempted = false;
      closeFillReminder(false);
      closeImageAssignment(false);
      closeCloudImport(false);
      closeLibrary(false);
      if (modal.parentNode !== document.body) document.body.appendChild(modal);
      modal.hidden = false;
      document.body.classList.add('trc-deck-editor-open');
      isolateBackground(true);
      render();
      emitChange();
      requestAnimationFrame(function () { modal.querySelector('.trc-deck-editor__close').focus(); });
    }

    function close() {
      if (modal.hidden) return closeSavePromise || saveInFlight || Promise.resolve(true);
      if (!frontCount()) emptyCloseAttempted = true;
      closeFillReminder(false);
      closeImageAssignment(false);
      closeCloudImport(false);
      closeLibrary(false);
      isolateBackground(false);
      modal.hidden = true;
      document.body.classList.remove('trc-deck-editor-open');
      if (modalAnchor.parentNode) modalAnchor.parentNode.insertBefore(modal, modalAnchor.nextSibling);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      renderClosedPreview(true);
      notifyChange();

      var pendingCloseSave = flushDraftSave().catch(function () { return false; });
      closeSavePromise = pendingCloseSave;
      pendingCloseSave.finally(function () {
        if (closeSavePromise === pendingCloseSave) closeSavePromise = null;
      });
      return pendingCloseSave;
    }

    function clear() {
      closeImageAssignment(false);
      closeCloudImport(false);
      var hadDefaultBackFile = !!defaultBackFile;
      if (items.length || slots.some(function (slot) { return !!slot.front || !!slot.back; }) || defaultBackFile) {
        rememberForUndo();
      }
      items = [];
      fileError = '';
      emptyCloseAttempted = false;
      slots = [];
      hiddenSlots = [];
      makeSlots(maximum);
      bulkInput.value = '';
      defaultBackFile = null;
      if (hadDefaultBackFile && typeof options.onRestoreDefaultBack === 'function') {
        options.onRestoreDefaultBack(null);
      }
      deleteDraft(persistenceKey).catch(function (error) { console.error('TRC deck draft clear failed', error); });
      render();
      emitChange();
    }

    function setDefaultBackFile(file) {
      var nextFile = file && contentType(file) ? file : null;
      if (nextFile === defaultBackFile) return;
      rememberForUndo();
      defaultBackFile = nextFile;
      render();
      emitChange();
    }

    function setLimits(nextMinimum, nextMaximum) {
      var next = Number(nextMaximum);
      if (!Number.isInteger(next) || next < 1 || (options.exactQuantity && next > 1000)) return false;
      if (options.exactQuantity && next === maximum) return true;
      if (!options.exactQuantity) {
        // Never discard the customer's layout because a smaller size was chosen.
        var allSlots = liveSlots(slots.concat(hiddenSlots));
        minimum = 1;
        maximum = next;
        slots = allSlots.slice(0, next);
        hiddenSlots = allSlots.slice(next);
        makeSlots(maximum);
        render();
        emitChange();
        return true;
      }
      var removed = slots.slice(next).map(function(slot,index){return slot.front || slot.back ? next + index + 1 : null;}).filter(Boolean);
      if (options.exactQuantity && removed.length && !window.confirm('Reducing to ' + next + ' cards removes occupied slots ' + removed.slice(0,20).join(', ') + (removed.length > 20 ? ' and ' + (removed.length - 20) + ' more' : '') + '. Continue?')) return false;
      if (options.exactQuantity) rememberForUndo();
      minimum = 1;
      maximum = next;
      makeSlots(maximum);
      render();
      emitChange();
      return true;
    }

    function useFilledCount() {
      var filled = filledSlots();
      if (!filled.length) return 0;
      rememberForUndo(); slots = filled; maximum = filled.length;
      render(); emitChange(); return maximum;
    }

    if (slotCountInput && options.exactQuantity) {
      function applySlotCount() {
        if (!slotCountInput.value || !slotCountInput.checkValidity()) {
          slotCountInput.reportValidity();
          return;
        }
        if (!setLimits(1, Number(slotCountInput.value))) slotCountInput.value = String(maximum);
      }
      var slotCountUpdate = document.getElementById('trcDeckEditorSlotCountUpdate');
      if (slotCountUpdate) slotCountUpdate.addEventListener('click', applySlotCount);
      slotCountInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') { event.preventDefault(); applySlotCount(); }
      });
    }

    document.getElementById('trcDeckEditorOpen').addEventListener('click', open);
    modal.querySelectorAll('button[data-trc-editor-close]').forEach(function (button) { button.addEventListener('click', close); });
    modal.addEventListener('click', function (event) {
      if (event.target === modal || !dialog.contains(event.target)) close();
    });
    if (libraryOpenButton) libraryOpenButton.addEventListener('click', openLibrary);
    if (libraryCloseButton) libraryCloseButton.addEventListener('click', function () { closeLibrary(true); });
    if (assignment) {
      assignment.querySelectorAll('[data-trc-assignment-close]').forEach(function (button) {
        button.addEventListener('click', function () { closeImageAssignment(true); });
      });
    }
    if (cloudImportButton) cloudImportButton.addEventListener('click', openCloudImport);
    if (cloudImport) {
      cloudImport.querySelectorAll('[data-trc-cloud-close]').forEach(function (button) {
        button.addEventListener('click', function () { closeCloudImport(true); });
      });
    }
    if (googleDriveButton) googleDriveButton.addEventListener('click', chooseGoogleDrive);
    if (dropboxButton) dropboxButton.addEventListener('click', function () {
      if (dropboxAccessToken) {
        setCloudProvider('dropbox');
        dropboxPathStack = [];
        dropboxSelectedEntries.clear();
        loadDropboxFolder('');
      } else {
        beginDropboxSignIn();
      }
    });
    if (dropboxUpButton) dropboxUpButton.addEventListener('click', function () {
      if (!dropboxPathStack.length) {
        showCloudProviders('', false);
        return;
      }
      dropboxPathStack.pop();
      var parent = dropboxPathStack.length ? dropboxPathStack[dropboxPathStack.length - 1].path : '';
      loadDropboxFolder(parent);
    });
    if (dropboxFolderButton) dropboxFolderButton.addEventListener('click', importDropboxFolder);
    if (dropboxSelectedButton) dropboxSelectedButton.addEventListener('click', importDropboxSelection);
    window.addEventListener('message', onDropboxOauthMessage);
    assignmentSideButtons.forEach(function (button) {
      button.addEventListener('click', function () { setAssignmentSide(button.dataset.trcAssignmentSide); });
    });
    if (assignmentSlot) assignmentSlot.addEventListener('change', function () {
      refreshAssignmentSlots(Number(assignmentSlot.value));
    });
    if (assignmentConfirm) assignmentConfirm.addEventListener('click', confirmImageAssignment);
    if (autofillButton) autofillButton.addEventListener('click', function () {
        if (!slots.some(function (slot) { return !slot.front; }) || !items.some(function (item) { return usage(item.id) === 0; })) return;
        rememberForUndo();
        autoFillFronts();
        render();
        emitChange();
        showFillFrontsReminder(fillReminder);
      });
    if (resetSlotsButton) resetSlotsButton.addEventListener('click', function () {
      if (!slots.some(function (slot) { return !!slot.front || !!slot.back; })) return;
      closeLibraryActionMenu(false);
      rememberForUndo();
      slots = [];
      hiddenSlots = [];
      makeSlots(maximum);
      emptyCloseAttempted = false;
      render();
      emitChange();
    });
    if (clearLibraryButton) clearLibraryButton.addEventListener('click', function () {
      closeLibraryActionMenu(false);
      clearLibrary();
    });
    document.addEventListener('click', function (event) {
      if (libraryActionMenu && libraryActionMenu.open && !libraryActionMenu.contains(event.target)) {
        closeLibraryActionMenu(false);
      }
    });
    libraryFilterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var nextFilter = button.dataset.trcLibraryFilter;
        if (!['all', 'used', 'unused'].includes(nextFilter) || nextFilter === libraryFilter) return;
        libraryFilter = nextFilter;
        prepareRenderLookups();
        try {
          renderLibrary();
        } finally {
          clearRenderLookups();
        }
      });
    });
    sizeEl.addEventListener('input', applySlotSize);
    if (slotFilterEl) slotFilterEl.addEventListener('change', render);
    if (viewEl) viewEl.addEventListener('change', render);
    if (changeBackButton) changeBackButton.addEventListener('click', function () {
      var input = document.querySelector('[data-cardback-file="images"]');
      if (!input) return;
      input.value = '';
      input.click();
    });
    if (resetBackButton) resetBackButton.addEventListener('click', function () {
      var remove = document.querySelector('[data-cardback-remove="images"]');
      if (remove) remove.click();
    });
    if (defaultBackEl) {
      defaultBackEl.draggable = true;
      defaultBackEl.title = 'Drag onto a Back slot';
      defaultBackEl.addEventListener('dragstart', function (event) {
        event.dataTransfer.setData('application/x-trc-default-back', 'default');
        event.dataTransfer.effectAllowed = 'copy';
        setDefaultBackDragPreview(event);
      });
      defaultBackEl.addEventListener('dragend', clearDefaultBackDragPreview);
    }
    if (addImagesButton) addImagesButton.addEventListener('click', function () {
      bulkInput.value = '';
      bulkInput.click();
    });
    bulkInput.addEventListener('change', function () {
      addFiles(bulkInput.files || [], { autofill: false });
      bulkInput.value = '';
    });
    slotInput.addEventListener('change', function () {
      if (pickTarget && slotInput.files && slotInput.files.length) {
        addFiles(slotInput.files, { target: pickTarget });
      }
      pickTarget = null;
      slotInput.value = '';
    });
    function draggedFiles(event) {
      if (!event.dataTransfer) return false;
      if (event.dataTransfer.files && event.dataTransfer.files.length) return true;
      return Array.from(event.dataTransfer.types || []).indexOf('Files') !== -1;
    }

    if (libraryPanel) {
      libraryPanel.addEventListener('dragover', function (event) {
        if (!draggedFiles(event)) return;
        event.preventDefault();
        libraryPanel.classList.add('is-dragover');
        libraryDrop.classList.add('is-dragover');
      });
      libraryPanel.addEventListener('dragleave', function (event) {
        if (event.relatedTarget && libraryPanel.contains(event.relatedTarget)) return;
        libraryPanel.classList.remove('is-dragover');
        libraryDrop.classList.remove('is-dragover');
      });
      libraryPanel.addEventListener('drop', function (event) {
        if (!draggedFiles(event) || !event.dataTransfer.files.length) return;
        event.preventDefault();
        libraryPanel.classList.remove('is-dragover');
        libraryDrop.classList.remove('is-dragover');
        addFiles(event.dataTransfer.files, { autofill: false });
      });
    }
    if (dialog) {
      dialog.addEventListener('dragover', updateDragAutoScroll);
      dialog.addEventListener('dragover', updateDragEdge);
      dialog.addEventListener('drop', stopDragAutoScroll);
      dialog.addEventListener('dragleave', function (event) {
        if (event.relatedTarget && dialog.contains(event.relatedTarget)) return;
        stopDragAutoScroll();
      });
    }
    document.addEventListener('dragend', stopDragAutoScroll, true);
    ['drop', 'dragend'].forEach(function (name) {
      document.addEventListener(name, function () {
        resetDragEdge();
        window.setTimeout(finishPagedDrag, 0);
      }, true);
    });
    if (workspace) workspace.addEventListener('dragleave', function (event) {
      if (!event.relatedTarget || !workspace.contains(event.relatedTarget)) resetDragEdge();
    });
    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (fillReminder && !fillReminder.hidden && event.key !== 'Tab') {
        if (event.key === 'Escape') { event.preventDefault(); closeFillReminder(true); }
        return;
      }
      if ((event.ctrlKey || event.metaKey) && !event.altKey && String(event.key).toLowerCase() === 'z') {
        var changed = event.shiftKey ? redo() : undo();
        if (changed) event.preventDefault();
        return;
      }
      if (event.key === 'Escape') {
        if (libraryActionMenu && libraryActionMenu.open) {
          closeLibraryActionMenu(true);
        } else if (cloudImport && !cloudImport.hidden) {
          closeCloudImport(true);
        } else if (assignment && !assignment.hidden) {
          closeImageAssignment(true);
        } else if (libraryPanel && libraryPanel.classList.contains('is-open')) {
          closeLibrary(true);
        } else {
          close();
        }
        return;
      }
      if (event.key !== 'Tab') return;
      var focusScope = fillReminder && !fillReminder.hidden ? fillReminder.querySelector('[role=alertdialog]') : cloudImport && !cloudImport.hidden && cloudDialog
        ? cloudDialog
        : (assignment && !assignment.hidden && assignmentDialog ? assignmentDialog : dialog);
      var focusable = Array.from(focusScope.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter(function (element) { return element.offsetParent !== null; });
      if (!focusable.length) {
        event.preventDefault();
        focusScope.focus();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    window.addEventListener('beforeunload', function (event) {
      if (!hasDraftData()) return;
      if (!draftDirty && !saveInFlight && !autosaveError) return;
      event.preventDefault();
      event.returnValue = '';
    });

    var cardbackPreview = document.querySelector('[data-cardback-img="images"]');
    if (cardbackPreview && window.MutationObserver) {
      new MutationObserver(function () {
        if (!modal.hidden) render();
      }).observe(cardbackPreview, { attributes: true, attributeFilter: ['src'] });
    }

    render();
    var restoreReady = restoreDraft();
    return {
      restoreFiles: async function (files, assignments) {
        await restoreReady;
        if (!Array.isArray(assignments) || !assignments.length || assignments.length > 1000) throw new Error('Invalid saved deck slots.');
        if (!options.exactQuantity && assignments.length > maximum) throw new Error('Saved deck exceeds this product size.');
        if (assignments.some(function (slot) { return !Number.isInteger(slot.frontFileIndex) || !files[slot.frontFileIndex] || (slot.backFileIndex != null && (!Number.isInteger(slot.backFileIndex) || !files[slot.backFileIndex])); })) throw new Error('Saved deck has a missing card image.');
        clear();
        if (options.exactQuantity) maximum = assignments.length;
        var added = addFilesNow(files, {autofill:false});
        if (added.length !== files.length) throw new Error('Some saved images could not be restored.');
        slots = Array.from({length:maximum}, function (_, index) {
          var saved = assignments[index];
          return {front:saved ? added[saved.frontFileIndex].id : null, back:saved && saved.backFileIndex != null ? added[saved.backFileIndex].id : null};
        });
        render(); emitChange();
      },
      open: open,
      close: close,
      clear: clear,
      plan: plan,
      validation: validation,
      setLimits: setLimits,
      useFilledCount: useFilledCount,
      setDefaultBackFile: setDefaultBackFile,
      undo: undo,
      redo: redo,
      render: render,
    };
  }

  window.TRCImageDeckEditor = { mount: mount, contentType: contentType };
  document.dispatchEvent(new CustomEvent('trc-image-deck-editor-ready'));
})();
